import React, { Component, createRef } from "react";
import { Link } from "react-router-dom";
import "./stylesheets/servicereport.css";
import HeaderBack from "../../../components/backoffice/headerback/HeaderBack";
import {
  deleteGeneratedJob,
  deletePickJob,
  delete_picklist_job,
  documentsUpload,
  generatePickListJob,
  getBackSiteid,
  getDocumentSelectId,
  getServiceGeneratedJobs,
  getServiceInvoicedJobs,
  getServicePickJobs,
  getServicePickJobsData,
  getServicePickSignedJobs,
  getServiceReport,
  getServiceSignedJobs,
  getServicegeneratedJobsData,
  getUploadDetails,
  saveGeneratedJob,
  savePickJobs,
  savePickListJob,
  saveSignedJob,
  signedGeneratedJob,
  fetchWorkorderList,
  saveSignedJobWithWorkorder,
  getServicePickJobsData_WO, 
  update_workorders,
  
} from "../../../modules/serverCall";
import "react-datepicker/dist/react-datepicker.css";
import BootstrapTable from "react-bootstrap-table-next";
import Moment from "moment";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import DatePicker from "react-datepicker";
import { IoIosInformationCircle } from "react-icons/io";
import { IoCalendarNumberOutline } from "react-icons/io5";
import { FiChevronsRight } from "react-icons/fi";
import { FaPlusCircle,FaMinusCircle,FaArrowAltCircleRight,FaCalendar,FaDownload,FaQuestion,} from "react-icons/fa";
import { Button,Dropdown,Offcanvas,FloatingLabel,Form,Table,Modal,} from "react-bootstrap";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import overlayFactory from "react-bootstrap-table2-overlay";
import Select from "react-select";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import { MdOutlinePreview } from "react-icons/md";

export default class ServiceReport extends Component {
 constructor(props) {
    super(props);
    this.bootstrapTableRef = createRef(); // Create a ref for Bootstrap Table

    const dateRange = [null, null];
    // const [startDate, endDate] = dateRange;

    this.state = {
      showData: false,
      scroll: false,
      startDate: null,
      calendarOpen: false,
      customerNameFilter: null,
      srIdFilter: null,
      jobFilter: null,
      endDate: null,
      backdrop: false,
      placement: "end",
      lodingImagData: false,
      showTooltip: false,
      showTooltipBox: false,
      dateRange: dateRange,
      srdetails: [],
      srSaveDate: "",
      srInvoicedDate: "2025-09-26",
      srSignedDate: "",
	  expectedBillingDate: "",
      documentArr: [],
      invoiceData: [],
      SRData: [],
      generatedSrData: "",
      AllowedFileExtensions: "",
      SRDataInvoice: [],
      selectedRows: [],
      customerJobData: "",
      showModal: false,
      ImageType: "",
      AllowedFileExtensions: "",
      MaxAllowedSize: "",
      imageId: "",
      Comment: "",
      imageData: "",
      expanded: [0, 1],
      image: require("../../../assets/images/blank-photo-image.png"),
      currnetmonthdata: new Date(),
      customer: "Equipment",
      listStatus: [
        { key: "0", value: "Jobs" },
        { key: "10", value: "Pick List" },
       // { key: "20", value: "Generated" },
       // { key: "30", value: "Signed" },
       // { key: "40", value: "Invoiced" },
      ],
      statusId: "0",
      selectedStatus: "Jobs",
      siteId: 0,
      selectedSite: "Site Id",
      editBtn: "",
      customerId: "",
      listSiteId: "",
      branchId: "",
      Permission: "",
      submitbtn: false,
      pickbtnEnabled: false,
      loading: false,
      showbtn: false,
      loadingData: "No data found",
	  showWorkorderModal: false,
	  workorderLines: [],
	  workorderCustomer: "",
	  selectedWorkorderLine: null,
	  workorderText: "",
	  WorkOrderJobid:"",
	  isWorkorderFetched: false,
	  allowJobQtyEdit: false,
      isDataFromDB: false,
	  isApiRow: true,  

    };
    this.wrapperRef = React.createRef();
    this.toggleCalendar = this.toggleCalendar.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.handleDataRemoveDetails = this.handleDataRemoveDetails.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleMouseEnterFetch = this.handleMouseEnterFetch.bind(this);
    this.handleMouseLeaveFetch = this.handleMouseLeaveFetch.bind(this);
	
	
  }
  
 componentDidMount() {
    window.scrollTo(0, 0);
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);
    const userId = readData.userdata.user_id;
    const accessselectedtentant = localStorage.getItem("selected_tenant");
    const readDataSelected = JSON.parse(accessselectedtentant);
    var ApplicationTenantID = readDataSelected.ApplicationTenantID;
    var editBtn = false;
    const permissionsdata = localStorage.getItem("permissions");
    const permissionsreadData = JSON.parse(permissionsdata);
    const filteredData = permissionsreadData.filter((obj) => {
      return (
        obj.PermissionCode === "VALIDATE_JOB" ||
        obj.PermissionCode === "AUTHORIZE_JOB"
      );
    });
    if (filteredData.length > 0) {
      if (filteredData[0].PermissionCode === "VALIDATE_JOB") {
        this.setState({
          Permission: filteredData[0].PermissionCode,
        });
      } else if (filteredData[0].PermissionCode === "AUTHORIZE_JOB") {
        this.setState({
          Permission: filteredData[0].PermissionCode,
        });
      }
    } else {
      this.setState({
        Permission: "",
      });
    }
    var sendDataSite = {
      userid: userId,
      applicationtenantId: ApplicationTenantID,
    };
    const fetchsiteid = async () => {
      const responsesites = await getBackSiteid(sendDataSite);
      const datarespsites = await responsesites;

      var sendDataBgType = {
        selectionType: 10,
      };

      const responseBgType = await getDocumentSelectId(sendDataBgType);
      const datarespBgType = await responseBgType;

      var SrGeneratedTypeIdArr = [];
      for (var i = 0; i < datarespBgType.length; i++) {
        var SrTypeId = {};
        SrTypeId.SelectionID = datarespBgType[i].SelectionID;
        SrTypeId.SelectionValue = datarespBgType[i].SelectionValue;
        SrGeneratedTypeIdArr.push(SrTypeId);
      }

      
      var siteIdArr = [];
      for (var i = 0; i < datarespsites.length; i++) {
        var siteId = {};
        siteId.key = datarespsites[i].SiteID;
        siteId.value = datarespsites[i].SiteName;
        siteId.BranchID = datarespsites[i].BranchID;
        siteIdArr.push(siteId);
      }

      const responseUploadsDetails = await getUploadDetails();
      const datarespUploadsDetails = await responseUploadsDetails;
      var FileType = responseUploadsDetails;

      
      this.setState({
        listSiteId: siteIdArr,
        selectedSite: siteIdArr[0].value,
        SrGeneratedTypeIdArr: SrGeneratedTypeIdArr,
        branchId: siteIdArr[0].BranchID,
        siteId: siteIdArr[0].key,
        uploadDetailsArr: FileType,
        AllowedFileExtensions: FileType[0].AllowedFileExtensions,
        MaxAllowedSize: FileType[0].MaxAllowedSize + " MB",
        // listEquipmentId:equipmentIdArr,
        // selectedEquipment:equipmentIdArr[0].value,
        // equipmentId:equipmentIdArr[0].key,
        // listComponentId:componentIdArr,
        // selectedComponent:componentIdArr[0].value,
        // componentId:componentIdArr[0].key,
        editBtn: editBtn,
      });
    };
    fetchsiteid();
    document.addEventListener("mousedown", this.handleOutsideClick);
  }

 componentDidUpdate(prevProps, prevState) {
  if (prevState.documentArr !== this.state.documentArr) {
    console.log("🔁 componentDidUpdate: documentArr changed:", this.state.documentArr);
  }
}

 componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleOutsideClick);
  }
  /*
  componentDidUpdate(prevProps, prevState) {
  if (prevState.invoicedNumber !== this.state.invoicedNumber) {
    console.log("invoicedNumber CHANGED:", this.state.invoicedNumber);
  }
}
*/
     
 handleOutsideClick(event) {
    
    console.log("ewjkhekf");
  }
  
 handleInputFetch = (event) => {
    var AllowanceArr = [];
    var submitbtn = true;
    var loadingData = "No data found";
    const siteId = this.state.siteId;

    this.setState({
      loading: true,
      loadingData: "Loading...",
    });

    if (this.state.selectedStatus === "Jobs") {
      const [startDateRange, endDateRange] = this.state.dateRange;

      var sendData = {
        siteId: siteId,
        startDate: Moment(startDateRange).format("YYYY-MM-DD"),
        endDate: Moment(endDateRange).format("YYYY-MM-DD"),
      };
      const fetchMappingdetails = async () => {
        var MappingArr = [];
        const responseMapping = await getServiceReport(sendData);
        const datarespMapping = await responseMapping;
        if (datarespMapping.length > 0) {
          console.log(datarespMapping);
          this.setState({
            loading: false,
            loadingData: "No data found",
          });
        } else {
          loadingData = "No data found";
          this.setState({
            loadingData: "No data found",
          });
        }
        this.setState({
          srdetails: datarespMapping,
          customerId: datarespMapping[0].CustomerID,
          loading: false,
          loadingData: "No data found",
        });
      };
      fetchMappingdetails();
    } 
	/*
	else if (this.state.selectedStatus === "Pick List") {

      var sendData = {
        siteId: siteId,
        CustomerID: null,
      };
      const fetchPickJobs = async () => {
        var MappingArr = [];
        const responseMapping = await getServicePickJobs(sendData);
        const datarespMapping = await responseMapping;
        if (datarespMapping.length > 0) {
          console.log(datarespMapping);
          this.setState({
            loading: false,
          });
        } else {
          loadingData = "No data found";
          this.setState({
            loadingData: "No data found",
          });
        }
        this.setState({
          srdetails: datarespMapping,
          loading: false,
          loading: false,
          //  loadingData: loadingData,
          // customerId: datarespMapping[0].CustomerID,
        });
      };
      fetchPickJobs();
    } */ 
	
	else if (this.state.selectedStatus === "Pick List") {
	  const [startDateRange, endDateRange] = this.state.dateRange;

	  if (!startDateRange || !endDateRange) {
		this.setState({
		  loading: false,
		  loadingData: "Please select date range",
		});
		return;
	  }

	  var sendData = {
		siteId: siteId,
		startDate: Moment(startDateRange).format("YYYY-MM-DD"),
		endDate: Moment(endDateRange).format("YYYY-MM-DD"),
	  };

	  const fetchPickJobs = async () => {
		const responseMapping = await getServicePickJobs(sendData);
		const datarespMapping = await responseMapping;

		this.setState({
		  srdetails: datarespMapping || [],
		  loading: false,
		  loadingData:
			datarespMapping?.length > 0 ? "No data found" : "No data found",
		});
		

	  };

	  fetchPickJobs();
	}
	
	else if (this.state.selectedStatus === "Signed") {
      var sendData = {
        siteId: siteId,
        CustomerID: null,
      };
      const fetchPickJobs = async () => {
        var MappingArr = [];
        const responseMapping = await getServiceSignedJobs(sendData);
        const datarespMapping = await responseMapping;
        if (datarespMapping.length > 0) {
          console.log(datarespMapping);
          this.setState({
            loading: false,
          });
        } else {
          loadingData = "No data found";
          this.setState({
            loadingData: "No data found",
          });
        }
        this.setState({
          srdetails: datarespMapping,
          loading: false,
          loading: false,
          //  loadingData: loadingData,
          // customerId: datarespMapping[0].CustomerID,
        });
      };
      fetchPickJobs();
    } else if (this.state.selectedStatus === "Invoiced") {
      var sendData = {
        siteId: siteId,
      };
      const fetchPickJobs = async () => {
        var MappingArr = [];
        const responseMapping = await getServiceInvoicedJobs(sendData);
        const datarespMapping = await responseMapping;
        if (datarespMapping === 200) {
          console.log(datarespMapping);
          this.setState({
            loading: false,
          });
        } else {
          loadingData = "No data found";
          this.setState({
            loadingData: "No data found",
          });
        }
        this.setState({
          srdetails: datarespMapping,
          loading: false,
          loading: false,
          loadingData: loadingData,
          // customerId: datarespMapping[0].CustomerID,
        });
      };
      fetchPickJobs();
    } else {
      var sendData = {
        siteId: siteId,
        CustomerID: null,
      };
      const fetchGeneratedJobs = async () => {
        var MappingArr = [];
        const responseMapping = await getServiceGeneratedJobs(sendData);
        const datarespMapping = await responseMapping;
        if (datarespMapping.length > 0) {
          console.log(datarespMapping);
        } else {
          loadingData = "No data found";
          this.setState({
            loadingData: "No data found",
          });
        }
        this.setState({
          srdetails: datarespMapping,
          loading: false,
          loading: false,
          loadingData: loadingData,
          // customerId: datarespMapping[0].CustomerID,
        });
      };
      fetchGeneratedJobs();
    }
  };

 toggleCalendar = () => {
    this.setState((prevState) => ({
      calendarOpen: !prevState.calendarOpen,
    }));
  };

 handleSavePick = () => {
    if (this.state.statusId === "0") {
      const siteId = this.state.siteId;
      const branchId = this.state.branchId;
      const CustomerID = this.state.customerId;

      this.setState({
        loading: true,
      });

      const submitPickList = async () => {
        const accesstokendata = localStorage.getItem("access_token");
        const readData = JSON.parse(accesstokendata);
        const userId = readData.userdata.user_id;
        var ApplicationTenantID = 0;
        const accessselectedtentant = localStorage.getItem("selected_tenant");
        if (
          accessselectedtentant !== "" &&
          accessselectedtentant !== null &&
          accessselectedtentant !== undefined
        ) {
          const readDataSelected = JSON.parse(accessselectedtentant);
          ApplicationTenantID = readDataSelected.ApplicationTenantID;
        }

        const { selectedRows } = this.state;

        const JobSRs = [];
        selectedRows.forEach((row) => {
          JobSRs.push({
            JobSRid: row.JobID,
            JobEndDate: Moment(row.JobEndDateTime).format("YYYY-MM-DD"),

            ActualJobDetails:
              "Date: " +
              Moment(row.JobStartDateTime).format("DD-MMM-YYYY") +
              ", Conv.ref: " +
              row.ConveyorReference +
              ", Work: " +
              row.JobType +
              ", Measures: " +
              row.Measures,
            SRJobDetails: "Note",
            JobType: row.JobType,
            OPFlag: "N",
          });
        });

        var sendData = {
          Siteid: siteId,
          BranchID: branchId,
          ModifiedBy: userId,
          CustomerID: CustomerID,
          ApplicationTenantID: ApplicationTenantID,
          JobSRs: JobSRs,
        };

        const responseMapping = await savePickJobs(sendData);
        const datarespMapping = await responseMapping;

        if (datarespMapping === 200) {
          this.handleInputFetch();
        }

        this.setState({
          srdetails: [],
          show: false,
          loading: false,
          submitbtn: false,
        });
      };

      Swal.fire({
        title: "Are you sure?",
        icon: "warning",
        showCancelButton: true,
        allowOutsideClick: false,
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          submitPickList();
          this.setState({
            selectedRows: [],
          });
          this.handleInputFetch();
        }
      });
    } else {
      const siteId = this.state.siteId;
      const branchId = this.state.branchId;
      const CustomerID = this.state.customerId;

      const signedPickList = async () => {
        const accesstokendata = localStorage.getItem("access_token");
        const readData = JSON.parse(accesstokendata);
        const userId = readData.userdata.user_id;
        var ApplicationTenantID = 0;
        const accessselectedtentant = localStorage.getItem("selected_tenant");
        if (
          accessselectedtentant !== "" &&
          accessselectedtentant !== null &&
          accessselectedtentant !== undefined
        ) {
          const readDataSelected = JSON.parse(accessselectedtentant);
          ApplicationTenantID = readDataSelected.ApplicationTenantID;
        }

        const { selectedRows } = this.state;

        const srIdsString = selectedRows.map((row) => row.ID).join(",");

        var sendData = {
          sr_ids: srIdsString,
          ModifiedBy: userId,
          ApplicationTenantID: ApplicationTenantID,
        };

        const responseMapping = await getServicePickSignedJobs(sendData);
        const datarespMapping = await responseMapping;

        console.log("datarespMapping", datarespMapping);

        if (datarespMapping.length > 0) {
          this.handleShow_WO("Invoice", datarespMapping);
        }

       
      };

      
      signedPickList();
    }
  };

 handleSaveSignedJob = () => {
    const siteId = this.state.siteId;
    const branchId = this.state.branchId;
    const CustomerID = this.state.customerId;

    const submitSignedJob = async () => {
      const accesstokendata = localStorage.getItem("access_token");
      const readData = JSON.parse(accesstokendata);
      const userId = readData.userdata.user_id;
      var ApplicationTenantID = 0;
      const accessselectedtentant = localStorage.getItem("selected_tenant");
      if (
        accessselectedtentant !== "" &&
        accessselectedtentant !== null &&
        accessselectedtentant !== undefined
      ) {
        const readDataSelected = JSON.parse(accessselectedtentant);
        ApplicationTenantID = readDataSelected.ApplicationTenantID;
      }

      var documentArr = this.state.documentArr;
     
      const JobSRs = [];
      this.state.invoiceData.forEach((row) => {
        JobSRs.push({
          JobSRid: row.SRID,
          JobEndDate: "2000-03-04",
          ActualJobDetails: "data",
          JobType: "data",
          SRJobDetails: "data",
          OPFlag: "E",
        });
      });

      

      var sendData = {
        Siteid: siteId,
        BranchID: branchId,
        ModifiedBy: userId,
        InvoiceDate: Moment(this.state.srInvoicedDate).format("YYYY-MM-DD"),
        InvoiceNum: this.state.invoicedNumber,
        // SRID: this.state.customerJobData.ID,
        ApplicationTenantID: ApplicationTenantID,
        // SRSaveDocuments: AllDocuments,
        JobSRs: JobSRs,
      };

      const responseMapping = await saveSignedJob(sendData);
      const datarespMapping = await responseMapping;

      if (datarespMapping === 200) {
        this.handleInputFetch();
      }

      this.setState({
        srdetails: [],
        show: false,
        submitbtn: false,
      });
    };

    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      allowOutsideClick: false,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        submitSignedJob();
        this.setState({
          selectedRows: [],
        });
        this.handleInputFetch();
        this.handleClose();
      }
    });
  };

 handleSavePickJob = () => {
    const siteId = this.state.siteId;
    const branchId = this.state.branchId;
    const CustomerID = this.state.customerId;
    const submitPickList = async () => {
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);
    const userId = readData.userdata.user_id;
    var ApplicationTenantID = 0;
    const accessselectedtentant = localStorage.getItem("selected_tenant");
      if (
        accessselectedtentant !== "" &&
        accessselectedtentant !== null &&
        accessselectedtentant !== undefined
      ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
        ApplicationTenantID = readDataSelected.ApplicationTenantID;
      }

    const JobSRs = [];
      this.state.SRData.forEach((row) => {
        JobSRs.push({
          JobSRid: row.JobID,
          JobEndDate: "2000-03-04",
          ActualJobDetails: row.ActualJobDetails,
          SRJobDetails: row.SRJobDetails,
          JobType: row.JobType,
          OPFlag: row.deleted ? "D" : "E",
        });
      });

    var sendData = {
        Siteid: siteId,
        BranchID: branchId,
        ModifiedBy: userId,
        SrDate: Moment(this.state.srSaveDate).format("YYYY-MM-DD"),
        PICKID: this.state.customerJobData.ID,
        ApplicationTenantID: ApplicationTenantID,
        JobSRs: JobSRs,
      };

    const responseMapping = await savePickListJob(sendData);
    const datarespMapping = await responseMapping;

    console.log(datarespMapping);

      if (datarespMapping === 200) {
        console.log("savePickListJobdattatata");
        this.setState({
          srSaveDate: "",
        });
        this.handleInputFetch();
      }

      this.setState({
        srdetails: [],
        show: false,
        submitbtn: false,
      });
    };

    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      allowOutsideClick: false,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        submitPickList();
        this.setState({
          selectedRows: [],
        });
        this.handleInputFetch();
        this.handleClose();
      }
    });
  };

 handleSaveGenerateJob = () => {
    const siteId = this.state.siteId;
    const branchId = this.state.branchId;
    const CustomerID = this.state.customerId;

    const submitGenerateList = async () => {
      const accesstokendata = localStorage.getItem("access_token");
      const readData = JSON.parse(accesstokendata);
      const userId = readData.userdata.user_id;
      var ApplicationTenantID = 0;
      const accessselectedtentant = localStorage.getItem("selected_tenant");
      if (
        accessselectedtentant !== "" &&
        accessselectedtentant !== null &&
        accessselectedtentant !== undefined
      ) {
        const readDataSelected = JSON.parse(accessselectedtentant);
        ApplicationTenantID = readDataSelected.ApplicationTenantID;
      }

      var documentArr = this.state.documentArr;
      console.log("documentArr", documentArr);

      var AllDocuments = [];

      if (documentArr.length > 0) {
		  console.log("Rendering documentArr:", this.state.documentArr);
        console.log("documentArr", documentArr);
        for (let index = 0; index < documentArr.length; index++) {
          const element = {};
          if (documentArr[index].DocumentID) {
            // If it's already uploaded, use the existing data
            element.SelectionID = documentArr[index].SelectionID;
            element.DocumentID = documentArr[index].DocumentID;
            element.FileName = documentArr[index].FileName;
            element.Description = documentArr[index].Description;
            element.UploadedBy = userId;
            element.SRDocumentID = documentArr[index].SRDocumentID;
            element.IsActive = true;
            AllDocuments.push(element);
          } else if (documentArr[index].ImageType === 1) {
            // If it's a new document, upload it
            var uploadedDocument = {
              document: documentArr[index].imageData,
              selection_type: documentArr[index].selectionType,
            };

            console.log("uploadedDocument", uploadedDocument);
            var resp = await documentsUpload(uploadedDocument);
            if (!resp) {
              this.setState({
                lodingImagData: false,
              });
            }
            var documentData = resp.document_id;
            var documentIdDate = documentData;
            element.SelectionID = documentArr[index].SelectionID;
            element.DocumentID = documentIdDate;
            element.FileName = documentArr[index].FileName;
            element.Description = documentArr[index].Description;
            element.UploadedBy = userId;
            element.SRDocumentID = documentArr[index].SRDocumentID;
            element.IsActive = true;
            AllDocuments.push(element);
          }
        }
      }

      console.log("AllDocuments", AllDocuments);

      const JobSRs = [];
      this.state.SRData.forEach((row) => {
        JobSRs.push({
          JobEndDate: "2000-03-04",
          JobSRid: row.JobID,
          ActualJobDetails: row.ActualJobDetails,
          SRJobDetails: row.SRJobDetails,
          OPFlag: row.deleted ? "D" : "E",
        });
      });

      // const SRSaveDocuments = [];
      // this.state.documentArr.forEach((row) => {
      //   SRSaveDocuments.push({
      //     SRDocumentID: row.SRDocumentID,
      //     SelectionID: row.SelectionID,
      //     DocumentID: row.SRJobDetails,
      //     UploadedBy: row.deleted ? "D" : "E",
      //     FileName: row.JobID,
      //     IsActive: row.ActualJobDetails,
      //     Description: row.Description,
      //   });
      // });

      var sendData = {
        Siteid: siteId,
        BranchID: branchId,
        ModifiedBy: userId,
        SrSignedDt: Moment(this.state.srSaveDate).format("YYYY-MM-DD"),
        SRID: this.state.customerJobData.ID,
        ApplicationTenantID: ApplicationTenantID,
        SRSaveDocuments: AllDocuments,
        JobSRs: JobSRs,
      };

      const responseMapping = await saveGeneratedJob(sendData);
      const datarespMapping = await responseMapping;

      if (datarespMapping === 200) {
        this.setState({
          srSaveDate: "",
          lodingImagData: false,
        });
        this.handleInputFetch();
      }

      this.setState({
        srdetails: [],
        show: false,
        submitbtn: false,
        lodingImagData: false,
      });
    };

    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      allowOutsideClick: false,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        submitGenerateList();
        this.setState({
          selectedRows: [],

          lodingImagData: true,
        });
        this.handleInputFetch();
        this.handleClose();
      }
    });
  };

 handleSignedGenerateJob = () => {
    const siteId = this.state.siteId;
    const branchId = this.state.branchId;
    const CustomerID = this.state.customerId;

    const submitGenerateList = async () => {
      const accesstokendata = localStorage.getItem("access_token");
      const readData = JSON.parse(accesstokendata);
      const userId = readData.userdata.user_id;
      var ApplicationTenantID = 0;
      const accessselectedtentant = localStorage.getItem("selected_tenant");
      if (
        accessselectedtentant !== "" &&
        accessselectedtentant !== null &&
        accessselectedtentant !== undefined
      ) {
        const readDataSelected = JSON.parse(accessselectedtentant);
        ApplicationTenantID = readDataSelected.ApplicationTenantID;
      }

      var documentArr = this.state.documentArr;

      var AllDocuments = [];

      if (documentArr.length > 0) {
        console.log("documentArr", documentArr);
        for (let index = 0; index < documentArr.length; index++) {
          const element = {};
          if (documentArr[index].ImageType === 1) {
            var uploadedDocument = {
              document: documentArr[index].imageData,
              selection_type: documentArr[index].selectionType,
            };

            // console.log("uploadedDocument", uploadedDocument);
            var resp = await documentsUpload(uploadedDocument);
            if (!resp) {
              this.setState({
                lodingImagData: false,
              });
            }
            var documentData = resp.document_id;
            var documentIdDate = documentData;
            element.SelectionID = documentArr[index].SelectionID;
            element.DocumentID = documentIdDate;
            element.FileName = documentArr[index].FileName;
            element.Description = documentArr[index].Description;
            element.UploadedBy = userId;
            element.SRDocumentID = documentArr[index].SRDocumentID;
            element.IsActive = true;
            AllDocuments.push(element);
          }
        }
      }

      const JobSRs = [];
      this.state.SRData.forEach((row) => {
        JobSRs.push({
          JobSRid: row.JobID,
          JobEndDate: "2000-03-04",
          ActualJobDetails: row.ActualJobDetails,
          SRJobDetails: row.SRJobDetails,
          OPFlag: row.deleted ? "D" : "E",
        });
      });

      

      var sendData = {
        Siteid: siteId,
        BranchID: branchId,
        ModifiedBy: userId,
        SrSignedDt: Moment(this.state.srSaveDate).format("YYYY-MM-DD"),
        SRID: this.state.customerJobData.ID,
        ApplicationTenantID: ApplicationTenantID,
        SRSaveDocuments: AllDocuments,
        JobSRs: JobSRs,
      };

      const responseMapping = await signedGeneratedJob(sendData);
      const datarespMapping = await responseMapping;

      if (datarespMapping === 200) {
        this.handleInputFetch();
        this.setState({
          lodingImagData: false,
        });
      }

      this.setState({
        srdetails: [],
        show: false,
        submitbtn: false,
      });
    };

    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      allowOutsideClick: false,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        submitGenerateList();
        this.setState({
          selectedRows: [],
          lodingImagData: true,
        });
        this.handleInputFetch();
        this.handleClose();
      }
    });
  };

 getFileNameWithoutExt = (fileName) => {
    return fileName ? fileName.replace(/\.[^/.]+$/, "") : "";
  };
  
 
 handleSaveSignedJobWithWorkorder = () => {
  console.log("💾 handleSaveSignedJobWithWorkorder triggered");

  const {
    customerId,
    customerJobData,
    invoicedNumber,
    srInvoicedDate,
    documentArr,
    SRData,
    selectedRows,
    siteId,
    branchId,
  } = this.state;

   const extractNumber = (val) => {
    if (!val) return 0;
    const match = String(val).match(/[\d.]+/);
    return match ? Number(match[0]) : 0;
  };


  const submitSignedJob = async () => {
    try {
      document.activeElement?.blur();

      const accesstokendata = localStorage.getItem("access_token");
      const readData = JSON.parse(accesstokendata);
      const userId = readData.userdata.user_id;

      let ApplicationTenantID = 0;
      const accessselectedtenant = localStorage.getItem("selected_tenant");
      if (accessselectedtenant) {
        const readDataSelected = JSON.parse(accessselectedtenant);
        ApplicationTenantID = readDataSelected.ApplicationTenantID;
      }
      const mergedSRData = SRData.map((row) => {
        const wo = (selectedRows || []).find(
          (s) => String(s.JobID) === String(row.JobID)
        );

		let workOrderQty = 0;
        if (row.PendingWorkorderList) {
          const parts = row.PendingWorkorderList.split("-").map(p => p.trim());
          if (parts.length >= 3) {
            workOrderQty = extractNumber(parts[2]);
          }
        }
			const jobQty = Number(
          wo?.JobId_QTY ?? row.JobId_QTY ?? row.Qty ?? 0
        );

        const billQty =
          row.manualBillQtyChange === true
            ? Number(row.BillQty)
            : Math.max(workOrderQty - jobQty, 0);
		
		return {
          ...row,
          JobId_QTY: jobQty,
          Qty: jobQty,
          BillQty: billQty,
          PendingWorkorderList:wo?.PendingWorkorderList ?? row.PendingWorkorderList ?? "",
        };
      });
		
      const JobSRs = mergedSRData.map((row) => {
        let WorkOrder = "";
        let ItemCode = "";
        let WorkOrder_Qty = 0;
        let WorkOrder_Rate = 0;

		
		if (row.PendingWorkorderList) {
          const parts = row.PendingWorkorderList.split("-").map(p => p.trim());
          if (parts.length >= 4) {
            WorkOrder = parts[0];
            ItemCode = parts[1];
            WorkOrder_Qty = extractNumber(parts[2]);
            WorkOrder_Rate = extractNumber(parts[3]);
          }
        }

        return {
          JobSRid: row.JobID,
          ActualJobDetails: row.ActualJobDetails || "",
          JobType: row.JobType || "",
          SRJobDetails: row.SRJobDetails || "",
          OPFlag: "I",
          JobEndDate:row.JobEndDate ||row.SRDate ||Moment().format("YYYY-MM-DD"),
          SpliceUOM: row.SpliceUOM || "",
          PendingWorkorderList: row.PendingWorkorderList || "",
          WorkOrder,
          ItemCode,
          JobId_QTY: Number(row.JobId_QTY) || 0,
		  JobId_QTY_Edited:  row.JobId_QTY_Edited !== null && row.JobId_QTY_Edited !== undefined? Number(row.JobId_QTY_Edited)    : 0,
		  WorkOrder_Qty,
          WorkOrder_Rate,
		  BillQty: Number(row.BillQty),
          BillingHold: row.BillingHold !== null ? row.BillingHold : false,
          ExpectedBillingDate: row.BillingHold? "2025-01-31": Moment(row.ExpectedBillingDate).isValid()? Moment(row.ExpectedBillingDate).format("YYYY-MM-DD"): "2025-01-31",
          Linenum: row.Linenum||0,
        };
      });
      //   HANDLE DOCUMENTS
      const AllDocuments = [];

      for (const doc of documentArr) {
        if (!doc.FileName || !doc.SelectionID) continue;

        const element = {
          SelectionID: doc.SelectionID,
          FileName: this.getFileNameWithoutExt(doc.FileName),
          Description:doc.Description || this.getFileNameWithoutExt(doc.FileName),
          UploadedBy: userId,
          SRDocumentID: doc.SRDocumentID || 0,
          IsActive: true,
        };
        if (doc.DocumentID && !doc.ImageType) {
          element.DocumentID = doc.DocumentID;
          AllDocuments.push(element);
          continue;
        }

        if (doc.ImageType === 1 && doc.imageData) {
          console.log("📤 Uploading new document:", doc.FileName);

          let base64Data = doc.imageData;
          if (base64Data.includes(",")) {
            base64Data = base64Data.split(",")[1];
          }

          const decoded = extractNumber(base64Data);
          if (!decoded) {
            console.warn("⚠️ Skipping invalid base64:", doc.FileName);
            continue;
          }

          const bytes = new Uint8Array(decoded.length);
          for (let i = 0; i < decoded.length; i++) {
            bytes[i] = decoded.charCodeAt(i);
          }

          const blob = new Blob([bytes], { type: "image/png" });
          const formData = new FormData();

          formData.append("document", blob, doc.FileName);
          formData.append(
            "selection_type",
            doc.SelectionID || doc.selectionType || 10
          );
          formData.append("application_tenant_id", ApplicationTenantID);
          formData.append("file_name", doc.FileName);
          formData.append("image_type", doc.ImageType || 1);

          try {
            const resp = await documentsUpload(formData);
            if (resp?.document_id) {
              element.DocumentID = resp.document_id;
              AllDocuments.push(element);
            }
          } catch (err) {
            console.error("Upload failed:", err);
          }
        }
      }

      const sendData = {
        BranchID: branchId,
        Siteid: siteId,
        ApplicationTenantID,
        PICKID: customerJobData?.ID || 0,
        CustomerID: selectedRows[0]?.CustomerId || customerId,
        SrDate: Moment().format("YYYY-MM-DD"),
        SRID: customerJobData?.ID || 0,
        SrSignedDt: Moment().format("YYYY-MM-DD"),
        InvoiceNum: invoicedNumber,
        InvoiceDate: srInvoicedDate? Moment(srInvoicedDate).format("YYYY-MM-DD"): "",
        ModifiedBy: userId,
        JobSRs,
        SRSaveDocuments: AllDocuments,
      };

      console.log("🚀 Final Payload:", sendData);

      const response = await saveSignedJobWithWorkorder(sendData);
      console.log("API Response:", response);

      if (response === 200) {
        this.handleInputFetch();
        this.setState({
			invoicedNumber: 1,
          show: false,
          submitbtn: false,
          lodingImagData: false,
        });
      }
    } catch (err) {
      console.error("❌ Error in handleSaveSignedJobWithWorkorder:", err);
      this.setState({ lodingImagData: false });
    }
  };

  Swal.fire({
    title: "Are you sure?",
    icon: "warning",
    showCancelButton: true,
    allowOutsideClick: false,
    confirmButtonText: "Yes",
    cancelButtonText: "No",
    reverseButtons: true,
  }).then((result) => {
    if (result.isConfirmed) {
      submitSignedJob();
      this.handleClose();
    }
  });
};

 handleSaveSignedJobSubmit = () => {
  console.log("💾 handleSaveSignedJobWithWorkorder triggered");

  const {
    customerId,
    customerJobData,
    invoicedNumber,
    srInvoicedDate,
    documentArr,
    SRData,
    selectedRows,
    siteId,
    branchId,
  } = this.state;

   const extractNumber = (val) => {
    if (!val) return 0;
    const match = String(val).match(/[\d.]+/);
    return match ? Number(match[0]) : 0;
  };


  const submitSignedJob = async () => {
    try {
      document.activeElement?.blur();

      const accesstokendata = localStorage.getItem("access_token");
      const readData = JSON.parse(accesstokendata);
      const userId = readData.userdata.user_id;

      let ApplicationTenantID = 0;
      const accessselectedtenant = localStorage.getItem("selected_tenant");
      if (accessselectedtenant) {
        const readDataSelected = JSON.parse(accessselectedtenant);
        ApplicationTenantID = readDataSelected.ApplicationTenantID;
      }
      const mergedSRData = SRData.map((row) => {
        const wo = (selectedRows || []).find(
          (s) => String(s.JobID) === String(row.JobID)
        );

		let workOrderQty = 0;
        if (row.PendingWorkorderList) {
          const parts = row.PendingWorkorderList.split("-").map(p => p.trim());
          if (parts.length >= 3) {
            workOrderQty = extractNumber(parts[2]);
          }
        }
			const jobQty = Number(
          wo?.JobId_QTY ?? row.JobId_QTY ?? row.Qty ?? 0
        );

        const billQty =
          row.manualBillQtyChange === true
            ? Number(row.BillQty)
            : Math.max(workOrderQty - jobQty, 0);
		
		return {
          ...row,
          JobId_QTY: jobQty,
          Qty: jobQty,
          BillQty: billQty,
          PendingWorkorderList:wo?.PendingWorkorderList ?? row.PendingWorkorderList ?? "",
        };
      });
		
      const JobSRs = mergedSRData.map((row) => {
        let WorkOrder = "";
        let ItemCode = "";
        let WorkOrder_Qty = 0;
        let WorkOrder_Rate = 0;

		
		if (row.PendingWorkorderList) {
          const parts = row.PendingWorkorderList.split("-").map(p => p.trim());
          if (parts.length >= 4) {
            WorkOrder = parts[0];
            ItemCode = parts[1];
            WorkOrder_Qty = extractNumber(parts[2]);
            WorkOrder_Rate = extractNumber(parts[3]);
          }
        }

        return {
          JobSRid: row.JobID,
          ActualJobDetails: row.ActualJobDetails || "",
          JobType: row.JobType || "",
          SRJobDetails: row.SRJobDetails || "",
          OPFlag: "I",
          JobEndDate:row.JobEndDate ||row.SRDate ||Moment().format("YYYY-MM-DD"),
          SpliceUOM: row.SpliceUOM || "",
          PendingWorkorderList: row.PendingWorkorderList || "",
          WorkOrder,
          ItemCode,
          JobId_QTY: Number(row.JobId_QTY) || 0,
		  JobId_QTY_Edited:  row.JobId_QTY_Edited !== null && row.JobId_QTY_Edited !== undefined    ? Number(row.JobId_QTY_Edited)    : 0,
		  WorkOrder_Qty,
          WorkOrder_Rate,
		  BillQty: Number(row.BillQty),
          BillingHold: row.BillingHold !== null ? row.BillingHold : false,
          ExpectedBillingDate: row.BillingHold? "2025-01-31": Moment(row.ExpectedBillingDate).isValid()? Moment(row.ExpectedBillingDate).format("YYYY-MM-DD"): "2025-01-31",
          Linenum: row.Linenum||0,
        };
      });
      //   HANDLE DOCUMENTS
      const AllDocuments = [];

      for (const doc of documentArr) {
        if (!doc.FileName || !doc.SelectionID) continue;

        const element = {
          SelectionID: doc.SelectionID,
          FileName: this.getFileNameWithoutExt(doc.FileName),
          Description:doc.Description || this.getFileNameWithoutExt(doc.FileName),
          UploadedBy: userId,
          SRDocumentID: doc.SRDocumentID || 0,
          IsActive: true,
        };
        if (doc.DocumentID && !doc.ImageType) {
          element.DocumentID = doc.DocumentID;
          AllDocuments.push(element);
          continue;
        }

        if (doc.ImageType === 1 && doc.imageData) {
          console.log("Uploading new document:", doc.FileName);

          let base64Data = doc.imageData;
          if (base64Data.includes(",")) {
            base64Data = base64Data.split(",")[1];
          }

          const decoded = extractNumber(base64Data);
          if (!decoded) {
            console.warn(" Skipping invalid base64:", doc.FileName);
            continue;
          }

          const bytes = new Uint8Array(decoded.length);
          for (let i = 0; i < decoded.length; i++) {
            bytes[i] = decoded.charCodeAt(i);
          }

          const blob = new Blob([bytes], { type: "image/png" });
          const formData = new FormData();

          formData.append("document", blob, doc.FileName);
          formData.append(
            "selection_type",
            doc.SelectionID || doc.selectionType || 10
          );
          formData.append("application_tenant_id", ApplicationTenantID);
          formData.append("file_name", doc.FileName);
          formData.append("image_type", doc.ImageType || 1);

          try {
            const resp = await documentsUpload(formData);
            if (resp?.document_id) {
              element.DocumentID = resp.document_id;
              AllDocuments.push(element);
            }
          } catch (err) {
            console.error("Upload failed:", err);
          }
        }
      }

      const sendData = {
        BranchID: branchId,
        Siteid: siteId,
        ApplicationTenantID,
        PICKID: customerJobData?.ID || 0,
        CustomerID: selectedRows[0]?.CustomerId || customerId,
        SrDate: Moment().format("YYYY-MM-DD"),
        SRID: customerJobData?.ID || 0,
        SrSignedDt: Moment().format("YYYY-MM-DD"),
        InvoiceNum: invoicedNumber,
        InvoiceDate: srInvoicedDate? Moment(srInvoicedDate).format("YYYY-MM-DD"): "",
        ModifiedBy: userId,
        JobSRs,
        SRSaveDocuments: AllDocuments,
      };

      console.log("🚀 Final Payload:", sendData);

      const response = await saveSignedJobWithWorkorder(sendData);
      console.log("API Response:", response);

      if (response === 200) {
        this.handleInputFetch();
        this.setState({
			invoicedNumber: 1,
          show: false,
          submitbtn: false,
          lodingImagData: false,
        });
      }
    } catch (err) {
      console.error("❌ Error in handleSaveSignedJobWithWorkorder:", err);
      this.setState({ lodingImagData: false });
    }
  };

  Swal.fire({
    title: "Are you sure?",
    icon: "warning",
    showCancelButton: true,
    allowOutsideClick: false,
    confirmButtonText: "Yes",
    cancelButtonText: "No",
    reverseButtons: true,
  }).then((result) => {
    if (result.isConfirmed) {
      submitSignedJob();
      this.handleClose();
    }
  });
};

 
 handleDeletePickJob = (data) => {
    const deletePickList = async () => {
      var sendData = {
        pick_list_id: data.ID,
      };

      const responseMapping = await deletePickJob(sendData);
      const datarespMapping = await responseMapping;

      if (datarespMapping === 200) {
        this.handleInputFetch();
      }

      this.setState({
        srdetails: [],
        show: false,
        submitbtn: false,
      });
    };

    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      allowOutsideClick: false,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        deletePickList();
        this.setState({
          selectedRows: [],
        });
        this.handleInputFetch();
      }
    });
  };

 handleDeleteGeneratedJob = (data) => {
    const deletePickList = async () => {
      var sendData = {
        sr_id: data.ID,
      };

      const responseMapping = await deleteGeneratedJob(sendData);
      const datarespMapping = await responseMapping;

      if (datarespMapping === 200) {
        this.handleInputFetch();
      }

      this.setState({
        srdetails: [],
        show: false,
        submitbtn: false,
      });
    };

    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      allowOutsideClick: false,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        deletePickList();
        this.setState({
          selectedRows: [],
        });
        this.handleInputFetch();
      }
    });
  };

 handleGeneratePickJob = () => {
    const siteId = this.state.siteId;
    const branchId = this.state.branchId;
    const CustomerID = this.state.customerId;

    const submitPickList = async () => {
      const accesstokendata = localStorage.getItem("access_token");
      const readData = JSON.parse(accesstokendata);
      const userId = readData.userdata.user_id;
      var ApplicationTenantID = 0;
      const accessselectedtentant = localStorage.getItem("selected_tenant");
      if (
        accessselectedtentant !== "" &&
        accessselectedtentant !== null &&
        accessselectedtentant !== undefined
      ) {
        const readDataSelected = JSON.parse(accessselectedtentant);
        ApplicationTenantID = readDataSelected.ApplicationTenantID;
      }

      const JobSRs = [];
      this.state.SRData.forEach((row) => {
        JobSRs.push({
          JobSRid: row.JobID,
          JobEndDate: "2000-03-04",
          ActualJobDetails: row.ActualJobDetails,
          SRJobDetails: row.SRJobDetails,
          JobType: row.JobType,
          OPFlag: row.deleted ? "D" : "E",
        });
      });

      var sendData = {
        Siteid: siteId,
        BranchID: branchId,
        ModifiedBy: userId,
        CustomerID: this.state.customerJobData.CustomerId,
        SrDate: Moment(this.state.srSaveDate).format("YYYY-MM-DD"),
        PICKID: this.state.customerJobData.ID,
        ApplicationTenantID: ApplicationTenantID,
        JobSRs: JobSRs,
      };

      const responseMapping = await generatePickListJob(sendData);
      const datarespMapping = await responseMapping;

      if (datarespMapping === 200) {
        this.handleInputFetch();
      }

      this.setState({
        srdetails: [],
        show: false,
        submitbtn: false,
      });
    };

    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      allowOutsideClick: false,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        submitPickList();
        this.handleSavePickJob();
        this.setState({
          selectedRows: [],
        });
        this.handleInputFetch();
        this.handleClose();
      }
    });
  };

 handleInputChange = (event) => {
    console.log(event);
    const [startDate, endDate] = event;
    const bothSelected = startDate && endDate;
    this.setState({
      dateRange: event,
      calendarOpen: !bothSelected,
      srdetails: [],
      show: false,
      submitbtn: false,
    });
  };

 handleSrSaveDateChange = (event) => {
    this.setState({
      srSaveDate: event,
    });
  };

 handleSrSaveInvoiceDateChange = (event) => {
    this.setState({
      srInvoicedDate: event,
    });
  };

 copyActualJobDetails = (index) => {
    const { SRData } = this.state;
    const updatedSRData = [...SRData];
    const actualJobDetails = updatedSRData[index]?.ActualJobDetails;

    // Update the SR Job Details with the Actual Job Details
    updatedSRData[index].SRJobDetails = actualJobDetails;

    // Update the state with the modified SRData
    this.setState({ SRData: updatedSRData });
  };

 handleInputSRDetailChange(index, value) {
    const updatedSRData = [...this.state.SRData];
    updatedSRData[index].SRJobDetails = value;
    this.setState({ SRData: updatedSRData });
  }

  handleDropdownSite = (key, event) => {
    // console.log(event.target.innerHTML);
    this.setState({
      selectedSite: event.target.innerHTML,
      siteId: key,
      srdetails: [],
      loadingData: "No data found",
      submitbtn: false,
      selectedRows: [],
      showData: false,
    });
  };

  handleDropdown = (key, event) => {
    this.setState({
      selectedStatus: event.target.innerHTML,
      statusId: key,
      dateRange: [null, null],
      loadingData: "No data found",
      srSaveDate: "",
      srdetails: [],
      SRData: [],
      selectedRows: [],
      show: false,
      showData: false,
      submitbtn: true,
    });

    this.handleClearFilter();
  };

  handleClearFilter = () => {
    const { customerNameFilter, srIdFilter, jobFilter } = this.state;
    if (customerNameFilter) customerNameFilter("");
    if (srIdFilter) srIdFilter("");
    if (jobFilter) jobFilter("");
  };

  handleDataAddDetails = (event) => {
    event.preventDefault();
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);
    const userId = readData.userdata.user_id;

    var newelement = {
      Job: [],
      Work: "Pulley Lagging",
      Measurements:
        "Length (mm): 22, Width (mm): 56, Thickness (mm): 67, Face Length (mm): 76, Dia (mm): 20",
      Dept: "MECHANICAL",
      ConvRef: "5",
      Date: "30-Oct-2023 09:00 AM-30-Oct-2023 12:45 PM - 225 Min",
      WorkOther: "Pulley Lagging",
      MeasurementsOther:
        "Length (mm): 22, Width (mm): 56, Thickness (mm): 67, Face Length (mm): 76, Dia (mm): 20",
      DeptOther: "MECHANICAL",
      ConvRefOther: "5",
      DateOther: "30-Oct-2023 09:00 AM-30-Oct-2023 12:45 PM - 225 Min",
    };
    this.setState((prevState) => ({
      SRData: [...prevState.SRData, newelement],
    }));
  };

 /* handleDataRemoveDetails(index) {
    const updatedSRData = [...this.state.SRData];
    updatedSRData[index].deleted = true;
    this.setState({ SRData: updatedSRData });
  }
*/

 handleDataRemoveDetails = (rowOrIndex) => {
  console.log("handleDataRemoveDetails called with:", rowOrIndex);

  let row = null;

  if (typeof rowOrIndex === "number") {
    row = this.state.SRData[rowOrIndex];
  } else if (rowOrIndex && typeof rowOrIndex === "object") {
    row = rowOrIndex;
  }

  if (!row) {
    console.warn("No row found to delete");
    return;
  }

  console.log("Row resolved for delete:", row);

  if (row.BillingHold === true) {
    Swal.fire({
      icon: "warning",
      title: "Delete not allowed",
      text: "This line item is under Billing and cannot be deleted.",
      confirmButtonText: "OK",
    });
    return;
  }
  
  //if (this.state.SRData.length === 1) 
	if ( this.state.SRData.length === 1 && String(this.state.SRData[0].Submitted) === "1")
  {
    Swal.fire({
      icon: "warning",
      title: "Delete not allowed",
      text: "Atleast one row required, delete not possible.",
      confirmButtonText: "OK",
    });
    return;
  }

  const jobId = row.JobID;
  const pickId = this.state.customerJobData?.ID;

  if (!jobId || !pickId) {
    console.error("Missing JobID or PickID", { jobId, pickId });
    return;
  }

  console.log("Deleting with payload:", {
    job_id: jobId,
    pick_id: pickId,
  });

  const deleteJobFromPick = async () => {
    try {
      const sendData = {
        JobId: jobId,
        pick_list_id: pickId,
      };

      const response = await delete_picklist_job(sendData); 
      console.log("Delete API response:", response);

      if (response === 200) {
        Swal.fire({
          icon: "success",
          title: "Deleted",
          text: "Line item removed successfully",
          timer: 1200,
          showConfirmButton: false,
        });
		
        this.handleInputFetch(); 
      }
    } catch (err) {
      console.error("Delete failed:", err);
      Swal.fire({
        icon: "error",
        title: "Delete failed",
        text: "Unable to delete this line item",
      });
    }
  };

  Swal.fire({
    title: "Are you sure?",
    text: "This line item will be removed from the pick list",
    icon: "warning",
    showCancelButton: true,
    allowOutsideClick: false,
    confirmButtonText: "Yes",
    cancelButtonText: "No",
    reverseButtons: true,
  }).then((result) => {
    if (result.isConfirmed) {
      deleteJobFromPick();	  
	  let filteredArray = this.state.SRData.filter(item => item.JobID !== row.JobID);
	  this.setState({
          SRData: filteredArray,
          invoicedNumber: 0, //  editable
          srSaveDate: filteredArray[0]?.SRDate
            ? Moment(filteredArray[0].SRDate).toDate()
            : "",
          submitbtn: true,
        }); 	  
    }
  });
};

 handleDataAddDetailsInvoice = (event) => {
    event.preventDefault();
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);
    const userId = readData.userdata.user_id;

    var newelement = {
      Job: [],
      Work: 0,
    };
    this.setState((prevState) => ({
      SRDataInvoice: [...prevState.SRDataInvoice, newelement],
    }));
  };

  handleDataRemoveDetailsInvoice = (event) => {
    this.setState({
      SRDataInvoice: this.state.Job.filter(function (SRDataInvoice, i) {
        // if(i === event && JobMaterialsEngg.KnownLanguageID !== 0){
        //   deleteknownlanguagedata(LanguagesData.KnownLanguageID);
        // }
        return i !== event;
      }),
    });
  };

 areAllDeleted() {
    return this.state.SRData.every((item) => item.deleted);
  }

 isSaveDisabled = () => {
  const { SRData, documentArr } = this.state;

  // console.group(" isSaveDisabled check");
  // console.log(" SRData:", SRData);
  // console.log(" documentArr (length):", documentArr?.length || 0, documentArr);
  console.groupEnd();

  if (!Array.isArray(SRData) || SRData.length === 0) return true;
  

  
  return false;

  let hasMissing = false; // track missing file/date

  for (const row of SRData) {
    if (row.BillingHold === false) {
      const hasDate =
        row.ExpectedBillingDate &&
        Moment(row.ExpectedBillingDate, ["YYYY-MM-DD", "MM/DD/YYYY"]).isValid();

      const hasFile =
        Array.isArray(documentArr) &&
        documentArr.some((doc) =>
          doc.JobID
            ? String(doc.JobID) === String(row.JobID)
            : !!doc.FileName
        );

      console.log(
        ` Row ${row.JobID}: hasDate=${hasDate}, hasFile=${hasFile}, documentArr.length=${documentArr.length}`
      );

      if (!hasDate || !hasFile) {
        console.warn(
          `Missing file/date for JobID ${row.JobID}: hasDate=${hasDate}, hasFile=${hasFile}`
        );
        hasMissing = true; // mark but don't return yet
      }
    }
  }

  // Only disable save if something missing or all rows deleted
  return hasMissing || this.areAllDeleted();
};

 handleDataChangeCheckList = (i) => (event) => {
  const { name, value } = event.target;

  const normalizedValue =
    value === "true" ? true :
    value === "false" ? false :
    value;

  this.setState((prevState) => {
    const updatedSRData = prevState.SRData.map((row, index) => {
      if (index !== i) return row;

      const updatedRow = { ...row, [name]: normalizedValue ,isApiRow: false,}; 

      if (name === "BillingHold" &&
        (normalizedValue === true || normalizedValue === false)
      ) {
		  const updatedRow = { ...row, BillingHold: normalizedValue };
        const pendingWorkorder = updatedRow?.PendingWorkorderList?.trim() || "";
        const pendingBillQty = updatedRow?.PendingBillQty ?? "";

        if (pendingBillQty === "" || Number(pendingBillQty) === 0) {
          Swal.fire({
            icon: "warning",
            title: "Missing Workorder",
            text: `Pending Workorder List is mandatory for Job ID ${updatedRow?.JobID || ""} when BillingHold is ${normalizedValue}.`,
          });
        } else if (
          pendingBillQty === "" ||Number(pendingBillQty) === 0 ||isNaN(pendingBillQty)
        ) {
          Swal.fire({
            icon: "warning",
            title: "Missing Pending Bill Quantity",
            text: `Pending Bill Qty is mandatory for Job ID ${updatedRow?.JobID || ""} when BillingHold is ${normalizedValue}.`,
          });
        }
      }

      return updatedRow;
    });

    return { SRData: updatedSRData };
  });
};

 handleExpectedBillingDateChange = (date, row) => {
  this.setState((prevState) => {
    const updatedSRData = prevState.SRData.map((r) =>
      String(r.JobID) === String(row.JobID)
        ? { ...r, ExpectedBillingDate: date } // only this jobid changes
        : r
    );

    return { SRData: updatedSRData };
  });
};

 handleClose = (event) => {
    this.setState({
      showData: false,
      documentArrData: [],
      documentArr: [],
      SRData: [],

      srInvoicedDate: "",
      invoicedNumber: "",
    });
  };

 handleCloseModal = (selected) => {
    this.setState({
      showModal: false,
      ImageType: "",
      image: require("../../../assets/images/blank-photo-image.png"),
      AllowedFileExtensions: "",
      MaxAllowedSize: "",
      Comment: "",
      imageId: "",
      imageData: "",
    });
  };

 handleShowModal = (selected) => {
    this.setState({
      showModal: true,
    });
  };

 handleCloseModalBig = (selected) => {
    this.setState({
      showModalBig: false,
      Comment: " ",
    });
  };

 handleFileUpload = (event, row) => {
  const file = event.target.files[0];
  if (!file) return;

  console.log(" File uploaded for row:", row.JobID, file.name);

  const reader = new FileReader();
  reader.onload = (e) => {
    const newDoc = {
      JobID: row.JobID,
      FileName: file.name,
      imageData: e.target.result,   // base64 data
      SelectionID: 10,              // or your default selection type
      ImageType: 1,
      Description: file.name,
    };

    this.setState((prevState) => {
      const updatedSRData = prevState.SRData.map((r) =>
        r.JobID === row.JobID
          ? { ...r, selectedFileName: file.name, fileData: file }
          : r
      );

      const updatedDocArr = [...prevState.documentArr, newDoc];

      console.log("documentArr updated:", updatedDocArr);

      return {
        SRData: updatedSRData,
        documentArr: updatedDocArr,
      };
    });
  };

  reader.readAsDataURL(file);
};

 handleShowModalBig = async (selected, DocumentID) => {
    var ApplicationTenantID = 0;
    const accessselectedtentant = localStorage.getItem("selected_tenant");
    if (
      accessselectedtentant !== "" &&
      accessselectedtentant !== null &&
      accessselectedtentant !== undefined
    ) {
      const readDataSelected = JSON.parse(accessselectedtentant);
      ApplicationTenantID = readDataSelected.ApplicationTenantID;
    }
    var urlObject = selected;
    const token = JSON.parse(localStorage.getItem("auth"));
    if (DocumentID !== "" && DocumentID !== null && DocumentID !== undefined) {
      var url =
        process.env.REACT_APP_API_URL +
        "/documents/" +
        DocumentID +
        "/?application_tenant_id=" +
        ApplicationTenantID;
      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      const blob = await res.blob();
      urlObject = URL.createObjectURL(blob);
    }

    this.setState({
      showModalBig: true,
      // viewFile:selected,
      viewFile: urlObject,
    });
  };

 handleDataRemoveImage = (event) => {
    var msg = "Are you sure you want to delete?.";
    Swal.fire({
      title: "Are you sure?",
      text: msg,
      icon: "warning",
      showCancelButton: true,
      allowOutsideClick: false,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({
          documentArr: this.state.documentArr.filter(function (
            documentArrData,
            i
          ) {
            // if(i === event && documentArrData.DocumentID !== 0){
            //   deleteImage(documentArrData);
            // }
            return i !== event;
          }),
        });
      }
    });
  };

 handleChangeImageDataOther = (event, row) => {
  console.log(" handleChangeImageDataOther called for JobID:", row?.JobID);
  const file = event.target.files[0];
  if (!file) {
    console.log("No file selected");
    return;
  }

  const reader = new FileReader();

  reader.onload = (e) => {
    console.log(" FileReader onload triggered for", file.name);
    const newDocument = {
      JobID: row?.JobID || null,
      FileName: file.name,
      imageData: e.target.result,
      SelectionID: 10,
      ImageType: 1,
      Description: file.name,
    };

    this.setState(
      (prev) => ({
        documentArr: [...prev.documentArr, newDocument],
      }),
      () => {
        console.log(" documentArr after upload:", this.state.documentArr);
      }
    );
  };

  reader.readAsDataURL(file);
};

 handleChange = (jobID, name, value) => {
  this.setState((prev) => ({
    SRData: prev.SRData.map((row) =>
      String(row.JobID) === String(jobID)
        ? { ...row, [name]: value, isApiRow: false }
        : row
    ),
  }));
};

  copyAllTasks = () => {
    const { srSaveDate, SRData } = this.state;

    console.log("SRData before copying tasks:", SRData);
    console.log("Selected date:", srSaveDate);

    if (!Array.isArray(SRData)) {
      console.error("SRData is not an array:", SRData);
      return;
    }

    try {
      this.setState(
        (prevState) => {
          const updatedSRData = prevState.SRData.map((row, index) => {
            if (!row.hasOwnProperty("ActualJobDetails")) {
              console.error(
                `Row at index ${index} is missing 'ActualJobDetails' property:`,
                row
              );
              throw new Error(
                `Row at index ${index} is missing 'ActualJobDetails' property`
              );
            }
            return {
              ...row,
              SRJobDetails: row.ActualJobDetails,
            };
          });
          return { SRData: updatedSRData };
        },
        () => {
          console.log("Copy all tasks executed successfully.");
          console.log("SRData after copying tasks:", this.state.SRData);
        }
      );
    } catch (error) {
      console.error("An error occurred while copying all tasks:", error);
      alert("An error occurred. Please try again.");
    }
  };

  handleChangeImage = (event) => {
    event.preventDefault();
    const MySwal = withReactContent(Swal);
    var checkImageData = this.state.imageData;
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);
    const userId = readData.userdata.display_name;
    var uploadDetailsArr = this.state.uploadDetailsArr;
    const filteredData = uploadDetailsArr.filter((obj) => {
      return obj.SelectionType === 10;
    });
    var SrGeneratedTypeIdArr = this.state.SrGeneratedTypeIdArr;
    console.log("SrGeneratedTypeIdArr", SrGeneratedTypeIdArr);
    // const filteredDataMain = selectionImage.filter((obj) => {
    //   return obj.SelectionType === parseInt(this.state.ImageType);
    // });
    if (
      checkImageData !== "" &&
      checkImageData !== null &&
      checkImageData !== undefined
    ) {
      if (filteredData.length > 0) {
        var fileName = checkImageData.name;
        var patternFileExtension = /\.([0-9a-z]+)(?:[\?#]|$)/i;
        var fileExtension = fileName.match(patternFileExtension);
        const MIN_FILE_SIZE = filteredData[0].MaxAllowedSize * 1024;
        const fileSizeKiloBytes = checkImageData.size / 1024;
        const uploadedFileType = checkImageData.type;
        const fileType = filteredData[0].AllowedFileExtensions;
        const fileTypeArray = fileType.split(",");
        const filteredFileType = fileTypeArray.find(
          (element) =>
            element === fileExtension[0] ||
            element.toUpperCase() === fileExtension[0]
        );
        if (
          filteredFileType !== undefined &&
          filteredFileType !== null &&
          filteredFileType !== ""
        ) {
          if (fileSizeKiloBytes < MIN_FILE_SIZE) {
            this.setState({
              lodingImagData: true,
            });
            var uploadedOn = Moment(new Date()).format("DD-MMM-YYYY HH:mm");
            var userData = this.state.documentArr;
            var element = {};
            element.SelectionID = SrGeneratedTypeIdArr[0].SelectionID;
            element.selectionType = 10;
            element.FileName = this.state.imageId;
            element.imageUrl = this.state.image;
            element.imageData = this.state.imageData;
            element.Description = this.state.Comment;
            element.SRDocumentID = 0;
            element.UploadedOn = uploadedOn;
            element.DocumentID = 0;
            element.ImageType = 1;
            element.SelectionValue = SrGeneratedTypeIdArr[0].SelectionValue;
            element.DeleteFlag = true;
            element.UploadedBy = userId;
            userData.push(element);
            this.setState(
              {
               // documentArr: userData,
				documentArr: JSON.parse(JSON.stringify(userData)),
              },
              () => {
                this.setState({
                  imageId: "",
                  imageData: "",
                  ImageType: "",
                  image: require("../../../assets/images/blank-photo-image.png"),
                  showModal: false,
                  lodingImagData: false,
                  Comment: "",
                });
              }
            );
          } else {
            var msg =
              "Maximum file size allowed " +
              filteredData[0].MaxAllowedSize +
              "MB";
            MySwal.fire(msg);
          }
        } else {
          var msg = "File type not allowed";
          MySwal.fire(msg);
        }
      } else {
        var msg = "Please select file type first";
        MySwal.fire(msg);
      }
    } else {
      var msg = "Please select file";
      MySwal.fire(msg);
    }
  };

  handleMouseEnter() {
    this.setState({ showTooltip: true });
  }

  handleMouseLeave() {
    this.setState({ showTooltip: false });
  }

  handleMouseEnterFetch() {
    this.setState({ showTooltipBox: true });
  }

  handleMouseLeaveFetch() {
    this.setState({ showTooltipBox: false });
  }

  navigateToServiceReportPreview = (id) => {
    // Set the ID in localStorage
    localStorage.setItem("service_report_id", "Generated");
  };

  navigateToServiceReportPreviewSigned = (id) => {
    localStorage.setItem("service_report_id", "Signed");
  };

  navigateToServiceReportPreviewPickList = (id) => {
    localStorage.setItem("service_report_id", "PickList");
  };

  navigateToServiceReportPreviewInvoice = (id) => {
    localStorage.setItem("service_report_id", "Invoice");
  };

  handleDataRemoveImage = (event) => {
    var msg = "Are you sure you want to delete?.";
    Swal.fire({
      title: "Are you sure?",
      text: msg,
      icon: "warning",
      showCancelButton: true,
      allowOutsideClick: false,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({
          documentArr: this.state.documentArr.filter(function (
            documentArrData,
            i
          ) {
            if (i === event && documentArrData.DocumentID !== 0) {
              // deleteImage(documentArrData);
            }
            return i !== event;
          }),
        });
      }
    });
  };

 getInitialBid = (oldValue, newValue, row, column) => {
    var indexData = row.index;
    var valueData = 0;
    
  };

 handleShow = (event, data) => {
    if (event === "New") {
      this.setState({
        customerJobData: data,
      });
      var sendData = {
        pick_id: data.ID,
      };
      const fetchPickJobs = async () => {
        const responseMapping = await getServicePickJobsData(sendData);
        const datarespMapping = await responseMapping;
        if (datarespMapping.length > 0) {
          console.log(datarespMapping);
        } else {
          // loadingData = "No data found";
        }
        this.setState({
          SRData: datarespMapping,
          srSaveDate: datarespMapping[0]?.SRDate
            ? Moment(datarespMapping[0]?.SRDate).toDate()
            : "",
          // customerId: datarespMapping[0].CustomerID,
        });
      };
      fetchPickJobs();
    } else if (event === "Invoice") {
      this.setState({
        invoiceData: data,
      });
    } else {
      this.setState({
        customerJobData: data,
      });
      var sendData = {
        sr_id: data.ID,
      };
      const fetchPickJobs = async () => {
        const responseMapping = await getServicegeneratedJobsData(sendData);

        this.setState({
          generatedSrData: responseMapping,
          documentArr: responseMapping?.SRDocuments,
          srSaveDate: responseMapping?.SRSignedDate
            ? Moment(responseMapping?.SRSignedDate).toDate()
            : "",
          // customerId: datarespMapping[0].CustomerID,
        });
      };
      fetchPickJobs();
    }
    this.setState({ showData: true, selectedBtn: event, customer: event });
  };

handleShow_WO = (event, data) => {
  if (event === "New") {
    this.setState({ customerJobData: data });
	
    const sendData = { pick_id: data.ID };

    const fetchPickJobs = async () => {
      const datarespMapping = await getServicePickJobsData_WO(sendData);

      if (Array.isArray(datarespMapping) && datarespMapping.length > 0) {
        const normalized = datarespMapping.map((row) => {
          const jobQty = Number(row.JobId_QTY ?? row.Qty ?? 0);
          const workQty = Number(row.WorkOrder_Qty ?? 0);

          const derivedBillQty =
            row.PendingBillQty ??
            row.BillQty ??
            (workQty > 0 ? Math.max(workQty - jobQty, 0) : 0);

          const isFrozen = row.BillingHold === true;

          return {
            ...row,
            PendingWorkorderList: row.PendingWorkorderList || "",
            JobId_QTY: jobQty,
            Qty: jobQty,
            Rate: row.WorkOrder_Rate ?? row.Rate ?? 0,
            BillQty: derivedBillQty,
            PendingBillQty: derivedBillQty,
            BillingHold:
              row.BillingHold === true
                ? true
                : row.BillingHold === false
                ? false
                : null,
            ExpectedBillingDate: row.ExpectedBillingDate
              ? Moment(row.ExpectedBillingDate).toDate()
              : "",
            isPrefilledHold: row.BillingHold === true,

            //  API row flags
            isApiRow: true,
            isFrozen,
            isQtyLocked: isFrozen,
            isRateLocked: isFrozen,
            isBillingHoldLocked: isFrozen,
          };
        });

        //  New jobs are NOT submitted
        this.setState({
          SRData: normalized,
          invoicedNumber: 0, //  editable
          srSaveDate: normalized[0]?.SRDate
            ? Moment(normalized[0].SRDate).toDate()
            : "",
          submitbtn: true,
        });
      }
    };

    fetchPickJobs();
  }

  // ===================== INVOICE VIEW =====================
  else if (event === "Invoice") {
    this.setState({ invoiceData: data });
  }

  // ===================== UPLOAD SIGNED SR =====================
  else if (event === "Upload Signed SR") {
    this.setState({ show: true, customerJobData: data });

    const sendData = { sr_id: data.ID };

    const fetchPickJobs = async () => {
      const responseMapping = await getServicegeneratedJobsData(sendData);

      const rows = responseMapping?.JobSRs || [];
      const submittedFlag = Number(
        responseMapping?.Submitted ??
        responseMapping?.InvoiceNum ??
        (rows[0]?.Submitted ?? rows[0]?.InvoiceNum ?? 0)
      );

      this.setState({
        generatedSrData: responseMapping,
        SRData: rows.map((row) => ({
          ...row,
          isPrefilledHold: row.BillingHold === true,
        })),
        documentArr: responseMapping?.SRDocuments || [],
        srSaveDate: responseMapping?.SRSignedDate
          ? Moment(responseMapping.SRSignedDate).toDate()
          : "",
        invoicedNumber: submittedFlag, //  CRITICAL FIX
        srInvoicedDate: responseMapping?.InvoiceDate
          ? Moment(responseMapping.InvoiceDate).toDate()
          : "",
      });
    };

    fetchPickJobs();
  }

  // ===================== VIEW SAVED / SUBMITTED SR =====================
  else {
    this.setState({ customerJobData: data });

    const sendData = { sr_id: data.ID };

    const fetchPickJobs = async () => {
      const responseMapping = await saveSignedJobWithWorkorder(sendData);

      const rows = responseMapping?.JobSRs || [];
      const submittedFlag = Number(
        responseMapping?.Submitted ??
        responseMapping?.InvoiceNum ??
        (rows[0]?.Submitted ?? rows[0]?.InvoiceNum ?? 0)
      );

      this.setState({
        generatedSrData: responseMapping,
        SRData: rows.map((row) => ({
          ...row,
          isPrefilledHold: row.BillingHold === true,
        })),
        documentArr: responseMapping?.SRDocuments || [],
        srSaveDate: responseMapping?.SRSignedDate
          ? Moment(responseMapping.SRSignedDate).toDate()
          : "",
        invoicedNumber: submittedFlag, //  CRITICAL FIX
        srInvoicedDate: responseMapping?.InvoiceDate
          ? Moment(responseMapping.InvoiceDate).toDate()
          : "",
      });
    };

    fetchPickJobs();
  }

  this.setState({
    showData: true,
    selectedBtn: event,
    customer: event,
  });
};

 handleDataChangeOther = (event) => {
    event.preventDefault();
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

 handleDataChangeComment = (event) => {
    const inputValue = event.target.value;
    if (inputValue.length <= 250) {
      this.setState({ Comment: inputValue });
    }
  };

 handleSelectAllRows = (e) => {
		  if (e.target.checked) {
			//this.setState({ selectedRows: [...this.state.srdetails] });
			 //this.setState({ selectedRows: [...this.state.SRData] });
			const allRows = [...this.state.SRData];
			this.setState({ selectedRows: allRows });
			console.log("handleSelectAllRows - selected all:", allRows);
		  } else {
		//	this.setState({ selectedRows: [] });
		  }
		};
			
 handleRowSelect = (e, row) => {
	  if (!row.JobID && !row.ID) {
		console.warn("Ignoring row without JobID/ID:", row);
		return;
	  }

	  let updatedSelectedRows = [...this.state.selectedRows];

	  if (e.target.checked) {
		if (
		  !updatedSelectedRows.some(
			(r) =>
			  (r.JobID && r.JobID === row.JobID) ||
			  (r.ID && r.ID === row.ID)
		  )
		) {
		 // updatedSelectedRows.push(row);
		 updatedSelectedRows.push(JSON.parse(JSON.stringify(row)));
		}
	  } else {
		updatedSelectedRows = updatedSelectedRows.filter(
		  (r) =>
			!(
			  (r.JobID && r.JobID === row.JobID) ||
			  (r.ID && r.ID === row.ID)
			)
		);
	  }

	  console.log("After update, selectedRows:", updatedSelectedRows);
	  this.setState({ selectedRows: updatedSelectedRows });
	};

 handleDuplicateRow = () => {
	  const { selectedRows, SRData } = this.state;
	  if (selectedRows.length === 0) {
		Swal.fire("Please select a row to split.");
		return;
	  }

  const newRows = selectedRows.map((row) => {
      const baseId = row.JobID;
      if (!baseId) {
		  console.warn("Skipping row without JobID:", row);
        return null;
      }

      // Copy all main fields
		
	  const newRow = {
        ...row,
       JobID: `${baseId}_11`, // unique split ID
       ID: null,
        deleted: false,
        selectedFileName: row.selectedFileName || "",
        fileData: row.fileData || null,
        manualBillQtyChange: false,
      };

      console.log("Split row created:", newRow);
      return newRow;
    })
    .filter(Boolean);

  this.setState((prevState) => ({
    SRData: [...prevState.SRData, ...newRows],
  }));

  Swal.fire("Row successfully split!");
};
	
 handleFieldChange = (e, jobID, rowIndex, field) => {
  const newValue = e.target.value;

  this.setState((prev) => ({
    SRData: prev.SRData.map((r, i) => {
      if (i !== rowIndex || String(r.JobID) !== String(jobID)) {
        return r;
      }

      const updatedRow = { ...r };

      if (field === "PendingBillQty") {
        const qty = Number(newValue) || 0;

        updatedRow.BillQty = qty;

        updatedRow.PendingBillQty = qty;

        updatedRow.manualBillQtyChange = true;

        updatedRow.isPendingQtyLocked = true;

        return updatedRow;
      }

      if (field === "Qty") {
        updatedRow.Qty = Number(newValue) || 0;

        // Auto-fill BillQty ONLY if user hasn't manually changed it
        if (!r.manualBillQtyChange) {
          updatedRow.BillQty = Number(newValue) || 0;
        }

        return updatedRow;
      }

      if (field === "BillQty") {
        updatedRow.BillQty = Number(newValue) || 0;

        // Prevent Qty from overriding
        updatedRow.manualBillQtyChange = true;

        return updatedRow;
      }

      updatedRow[field] = newValue;
      return updatedRow;
    }),
  }));
};

 handleDeleteRow = (row) => {
	  const updatedData = this.state.SRData.filter(
		(r) =>
		  !(
			(r.JobID && r.JobID === row.JobID) ||
			(r.ID && r.ID === row.ID)
		  )
	  );
	  this.setState({ SRData: updatedData });
	};

 handleMergeRows = () => {
  const { selectedRows, SRData } = this.state;

  if (selectedRows.length < 2) {
    Swal.fire("Please select at least two rows to merge.");
    return;
  }

  const normalizedJobTypes = [
    ...new Set(
      selectedRows
        .map(r => (r.JobType || "").trim().toLowerCase())
        .filter(jt => jt !== "")
    ),
  ];

  if (normalizedJobTypes.length > 1) {
    const displayTypes = [
      ...new Set(selectedRows.map(r => (r.JobType || "").trim()).filter(Boolean)),
    ].join(", ");
    Swal.fire({
      icon: "error",
      title: "Cannot merge different job types",
      text: `Selected rows have multiple Job Types: ${displayTypes}`,
    });
    return;
  }

  const finalJobType =
    selectedRows.find(r => (r.JobType || "").trim() !== "")?.JobType?.trim() || "";
  const safeJoin = arr => arr.filter(Boolean).join(", ");
  const safeSum = field =>
    selectedRows.reduce((acc, row) => {
      const val = parseFloat(row[field]);
      return acc + (isNaN(val) ? 0 : val);
    }, 0);

  const uomSet = new Set(selectedRows.map(r => r.SpliceUOM || "").filter(Boolean));
  const mergedUOM = uomSet.size === 1 ? [...uomSet][0] : "";

  const mergedRow = {
    JobID: safeJoin(selectedRows.map(r => r.JobID)),
    JobType: finalJobType, //  always consistent
    ActualJobDetails: safeJoin(selectedRows.map(r => r.ActualJobDetails)),
    SRJobDetails: safeJoin(selectedRows.map(r => r.SRJobDetails)),
    PendingWorkorderList: safeJoin(selectedRows.map(r => r.PendingWorkorderList)),
    SpliceUOM: mergedUOM,
    Qty: safeSum("Qty") || "",
    Rate: safeSum("Rate") || "",
    BillQty: safeSum("BillQty") || "",
    BillingHold: safeJoin(selectedRows.map(r => r.BillingHold)),
    UploadSR: "",
  };

  const updatedData = [
    ...SRData.filter(r => !selectedRows.includes(r)),
    mergedRow,
  ];

  this.setState({
    SRData: updatedData,
    selectedRows: [mergedRow],
  });

  console.log("Merged row created:", mergedRow);
};

 handleFetchWorkorderList = (row) => {
  //const customerId = this.state.selectedRows[0]?.CustomerId;
   const customerId =row?.CustomerID ||row?.CustomerId ||
    this.state.selectedRows?.[0]?.CustomerID ||
    this.state.selectedRows?.[0]?.CustomerId ||
    this.state.customerJobData?.CustomerID ||
    this.state.customerJobData?.CustomerId ||
    this.state.customerId ||0;
	this.setState({ allowJobQtyEdit: false });

  const customerName = this.state.customerJobData?.CustomerName;
  const JobID = row.JobID;
  const JobType = (row?.JobType || "").trim();

  console.log("Fetching workorders for customer:", customerId, JobID, JobType);
  console.log("Selected row:", row);
  
if (!customerId || customerId === 0 || customerId === "undefined") {
    Swal.fire({
      icon: "warning",
      title: "Missing Customer ID",
      text: "Customer ID not found for this job. Please verify job selection.",
    });
    return;
  }

  if (!customerName) {
    console.error("No customer name found, cannot fetch workorders");
    return;
  }

  fetchWorkorderList(customerId, JobID, JobType)
    .then((data) => {
      if (!data || data.length === 0) {
        console.warn(" No workorders found");
        Swal.fire("No workorder found", "", "info");
        return;
      }

      console.log(`Retrieved ${data.length} total workorders`);

      // --- Prefill logic (keep your original) ---
      const prevMatch = this.state.SRData.find(
        (r) =>
          r.JobID !== JobID &&
          String(r.PendingWorkorderList || "").trim() ===
            String(row.PendingWorkorderList || "").trim()
      );

      if (prevMatch) {
        const pendingQty = Number(prevMatch.PendingBillQty || 0);
        console.log(
          `Found previous JobID ${prevMatch.JobID} with same workorder → PendingQty = ${pendingQty}`
        );

        this.setState((prevState) => {
          const updatedSRData = prevState.SRData.map((r) => {
            if (r.JobID === JobID) {
              return {
                ...r,
                Qty: pendingQty,
                BillQty: pendingQty,
              };
            }
            return r;
          });
          return { SRData: updatedSRData };
        });
      }

      //  Update modal state
      this.setState({
        workorderLines: data,
        workorderCustomer: customerName,
        showWorkorderModal: true,
        WorkOrderJobid: JobID,
        descriptionFilter: "",
        workorderFilter: "",
        isWorkorderFetched: true,
      });
    })
    .catch((error) => {
      console.error(" Error fetching workorder list:", error);
      Swal.fire("Error fetching workorders", error.message, "error");
    });
};
 
 handleGetWorkorderListWithoutJobType = (row) => {
  const customerId =row?.CustomerID ||row?.CustomerId ||
    this.state.selectedRows?.[0]?.CustomerID ||
    this.state.selectedRows?.[0]?.CustomerId ||
    this.state.customerJobData?.CustomerID ||
    this.state.customerJobData?.CustomerId ||
    this.state.customerId ||0;
	this.setState({ allowJobQtyEdit: true });

  const customerName = this.state.customerJobData?.CustomerName;
  const JobID = row.JobID; // row.JobID
 // const JobType = null;
  const JobType =null;
   this.setState({ allowJobQtyEdit: true });
  console.log("Fetching workorders for customer:", customerId, JobID, JobType);
  console.log("Selected row:", row);
  
  if (!customerId || customerId === 0 || customerId === "undefined") {
    Swal.fire({
      icon: "warning",
      title: "Missing Customer ID",
      text: "Customer ID not found for this job. Please verify job selection.",
    });
    return;
  }

  if (!customerName) {
    console.error(" No customer name found, cannot fetch workorders");
    return;
  }

  fetchWorkorderList(customerId, JobID, JobType)
    .then((data) => {
      if (!data || data.length === 0) {
        console.warn(" No workorders found");
        Swal.fire("No workorder found", "", "info");
        return;
      }

      console.log(`Retrieved ${data.length} total workorders`);

      const prevMatch = this.state.SRData.find(
        (r) =>
          r.JobID !== JobID &&
          String(r.PendingWorkorderList || "").trim() ===
            String(row.PendingWorkorderList || "").trim()
      );

      if (prevMatch) {
        const pendingQty = Number(prevMatch.PendingBillQty || 0);
        console.log(
          `Found previous JobID ${prevMatch.JobID} with same workorder → PendingQty = ${pendingQty}`
        );

        this.setState((prevState) => {
          const updatedSRData = prevState.SRData.map((r) => {
            if (r.JobID === JobID) {
              return {
                ...r,
                Qty: pendingQty,
                BillQty: pendingQty,
              };
            }
            return r;
          });
          return { SRData: updatedSRData };
        });
      }

      this.setState({
        workorderLines: data,
        workorderCustomer: customerName,
        showWorkorderModal: true,
        WorkOrderJobid: JobID,
        descriptionFilter: "",
        workorderFilter: "",
        isWorkorderFetched: true,
      });
    })
    .catch((error) => {
      console.error("Error fetching workorder list:", error);
      Swal.fire("Error fetching workorders", error.message, "error");
    });
};

 handleSelectWorkorderLine = (line) => {
	 console.log("handleSelectWorkorderLine called with:", line);
  this.setState({ selectedWorkorderLine: line });
	};
  
 handlePendingBillQtyChange = (value, row) => {
  const qty = Number(row.Qty) || 0;
  const pendingBillQty = Number(value) || 0;

  //  Validation: PendingBillQty cannot exceed Qty
  if (pendingBillQty > qty) {
    Swal.fire({
      icon: "error",
      title: "Invalid Quantity",
      text: `Pending Bill Qty (${pendingBillQty}) cannot be greater than Qty (${qty}).`,
    });
    return; // stop update
  }

  //  Proceed with normal update
  this.setState((prevState) => {
    const updatedSRData = prevState.SRData.map((r) =>
      String(r.JobID) === String(row.JobID)
        ? { ...r, PendingBillQty: value } // update only this job
        : r
    );
    return { SRData: updatedSRData };
  });
};

 handleSubmitWorkorderList = async () => {
  const { selectedWorkorderLine, WorkOrderJobid, SRData, selectedRows } = this.state;

  if (!selectedWorkorderLine || Object.keys(selectedWorkorderLine).length === 0) {
    Swal.fire({
      icon: "warning",
      title: "Please select a workorder line before submitting!",
      confirmButtonText: "OK",
    });
    return;
  }

  const customerId = this.state.selectedRows[0]?.CustomerId;
  const WorkOrderNumber = selectedWorkorderLine.WorkOrderNumber || selectedWorkorderLine.WorkOrderNo || "";
  const ItemCode = selectedWorkorderLine.ItemCode || selectedWorkorderLine.Item_Code || "";
  const unitMsr = selectedWorkorderLine.unitMsr || selectedWorkorderLine.UOM || "";
  const Price = Number(selectedWorkorderLine.Price || selectedWorkorderLine.Rate || 0);
  const Quantity = Number(selectedWorkorderLine.Quantity || selectedWorkorderLine.WorkOrder_Qty || 0);
  const JobId_QTY = Number(selectedWorkorderLine.JobId_QTY || selectedWorkorderLine.JobQty || 0);
  const JobId_QTY_Edited =selectedWorkorderLine.JobId_QTY_Edited !== undefined &&selectedWorkorderLine.JobId_QTY_Edited !== null &&String(selectedWorkorderLine.JobId_QTY_Edited).trim() !== ""    ? Number(selectedWorkorderLine.JobId_QTY_Edited): null;
 
  const Linenum = selectedWorkorderLine.Linenum !== undefined &&selectedWorkorderLine.Linenum !== null? Number(selectedWorkorderLine.Linenum): null;
  const finalQty = JobId_QTY_Edited !== null ? JobId_QTY_Edited : JobId_QTY;
  const workorderText = `${WorkOrderNumber} - ${ItemCode} - ${Quantity} ${unitMsr} - ${Price}`;

  const updatedData = SRData.map((r) => {
    if (String(WorkOrderJobid) === String(r.JobID)) {
      const pendingBillQty = Math.max(Quantity - JobId_QTY, 0);
      return {
        ...r,
        PendingWorkorderList: workorderText,
        Qty: finalQty,
		JobId_QTY: JobId_QTY,
		JobId_QTY_Edited: JobId_QTY_Edited,
		Linenum: Linenum ?? null, 
        Rate: Price,
        SpliceUOM: unitMsr,
     	PendingBillQty: Math.max(Quantity - finalQty, 0),
      };
    }
    return r;
  });

  console.log(" Updated SRData with PendingBillQty:", updatedData);

  // 🧾 Prepare payload
  const payload = {
    customerId,
    WorkOrderNumber,
    ItemCode,
    Quantity,
    Price,
    JobId_QTY,
	JobId_QTY_Edited: JobId_QTY_Edited||0,
    Linenum: Linenum
	
  };

  console.log("🚀 Sending update_workorders payload:", payload);

  if (!WorkOrderNumber || !ItemCode) {
    Swal.fire({
      icon: "error",
      title: "Missing required fields!",
      text: "WorkOrderNumber or ItemCode cannot be empty.",
    });
    return;
  }

  try {
    const res = await update_workorders(
      payload.customerId,
      payload.WorkOrderNumber,
      payload.ItemCode,
      payload.JobId_QTY,
	  payload.JobId_QTY_Edited,
	  payload.Quantity,
      payload.Price,
	  payload.Linenum,
    );

    if (res === 200 || res?.status === 200 || res?.status === 204) {
      Swal.fire({
        icon: "success",
        title: "Workorder updated successfully!",
        confirmButtonText: "OK",
      });
    } else {
      // Fallback notice for empty response
      Swal.fire({
        icon: "success",
        title: "WO ROW Updated",
        text: `Server responded with: ${res?.status || "204 No Content"}`,
      });
    }
  } catch (err) {
    console.error("update_workorders API error:", err);
    Swal.fire({
      icon: "error",
      title: "API Error",
      text: err?.message || "Error while updating workorder.",
    });
  }

  this.setState({
    SRData: updatedData,
    showWorkorderModal: false,
    selectedWorkorderLine: null,
    workorderText,
    isWorkorderFetched: false,
  });
};

 handleJobIdQtyChange = (value, index) => {
  const updated = [...this.state.workorderLines];
  updated[index].JobId_QTY_Edited = value;
  this.setState({ workorderLines: updated });
};

 loadSRData = (responseData) => {
	  const withDefaults = responseData.map((r) => ({
		...r,
		Qty: r.Qty ?? "",
		Rate: r.Rate ?? "",
		SpliceUOM: r.SpliceUOM ?? "",
		PendingWorkorderList: r.PendingWorkorderList ?? "",
		ExpectedBillingDate: r.ExpectedBillingDate ?? "" , 
	  }));
	  this.setState({ SRData: withDefaults });
	};

 isFetchDisabled = () => {
  const { selectedStatus, dateRange } = this.state;
  const [startDate, endDate] = dateRange;

  if (
    (selectedStatus === "Jobs" || selectedStatus === "Pick List") &&
    (!startDate || !endDate)
  ) {
    return true;
  }

  return false;
};

  render() {

    const SRData = this.state.SRData;

    const SRDataInvoice = this.state.SRDataInvoice;
    const addUserLogo = require("../../../assets/images/add_user.png");
    const terminationLogo = require("../../../assets/images/termination.png");
    const loadingImg = require("../../../assets/images/Hourglass.gif");
		
	var listSiteId = this.state.listSiteId;
    var listStatus = this.state.listStatus;
    var documentArr = this.state.documentArr;

    console.log("selectedRows", this.state.selectedRows);
	
 
    var columns = [];
    if (this.state.statusId === "20") {
      columns = [
        {
          dataField: "ID",
          text: "SR #",
          classes: "cursorPoint id-width",
          filter: textFilter({
            className: "filter_class",
            getFilter: (filter) => {
              this.setState({ srIdFilter: filter });
            },
          }),
          sort: true,
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              this.handleShow_WO("Upload Signed SR", row);
            },
          },
        },
     
	 {
          dataField: "CustomerName",
          text: "Customer",
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              this.handleShow_WO("Upload Signed SR", row);
            },
          },
          classes: "cursorPoint customerName-Width",
          // filter: textFilter({ className: "filter_class" }),
          filter: textFilter({
            className: "filter_class",
            getFilter: (filter) => {
              this.setState({ customerNameFilter: filter });
            },
          }),
          sort: true,
        },
        {
          dataField: "JobSRTypeIds",
          classes: "cursorPoint",
          text: "Jobs",
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              this.handleShow_WO("Upload Signed SR", row);
            },
          },
          filter: textFilter({
            className: "filter_class",
            getFilter: (filter) => {
              this.setState({ jobFilter: filter });
            },
          }),
          sort: true,
        },
        {
          dataField: "SRDate",
          classes: "cursorPoint srDate-Width",
          text: "SR Date",
          // filter: textFilter({ className: "filter_class" }),
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              this.handleShow_WO("Upload Signed SR", row);
            },
          },
          sort: true,
          formatter: (cellContent, row) => {
            return Moment(row.SRDate).format("DD-MMM-YYYY");
          }
		},
				
			{
			  dataField: "Action",
			  text: "Action",
			  classes: "actionbtncustm",
			  isDummyField: true,
			  editable: false,
			  formatter: (cellContent, row) => {
				return (
				  <span>
					<span className="saveBtnUs">
					  <Link
						target="_blank"
						to={`/service-report-preview/${row.ID}`}
						onClick={() => this.navigateToServiceReportPreview(row.ID)}
						className="linkPage"
					  >
						<MdOutlinePreview size={20} title="Preview" />{" "}
					  </Link>
					</span>
					
					<span
					  className="saveBtnUsMi cursorPoint marginLeft"
					  onClick={() => this.handleDeleteGeneratedJob(row)}
					>
					  <FaMinusCircle className="btnClassMinus" title="Delete" />
					</span> 
					
				  </span>
				);
			  },
			},

	  
	  ];
    } else if (this.state.statusId === "30") {
      columns = [
        {
          dataField: "ID",
          text: "SR #",
          // filter: textFilter({ className: "filter_class" }),
          classes: "cursorPoint id-width",
          sort: true,
          // events: {
          //   onClick: (e, column, columnIndex, row, rowIndex) => {
          //     this.handleShow("Invoice", row);
          //   },
          // },
        },
        {
          dataField: "CustomerName",
          text: "Customer",
          classes: "cursorPoint customerName-Width",
          filter: textFilter({
            className: "filter_class",
            getFilter: (filter) => {
              this.setState({ customerNameFilter: filter });
            },
          }),
          sort: true,
        },
        {
          dataField: "JobSRTypeIds",
          text: "Jobs",
          classes: "cursorPoint",
          filter: textFilter({
            className: "filter_class",
            getFilter: (filter) => {
              this.setState({ jobFilter: filter });
            },
          }),
          sort: true,
        },
		
						{
				  dataField: "SRDate",
				  classes: "cursorPoint srDate-Width",
				  text: "SR Date",
				  events: {
					onClick: (e, column, columnIndex, row, rowIndex) => {
					  this.handleShow_WO("Upload Signed SR", row);
					},
				  },
				  sort: true,
				  formatter: (cellContent, row) => {
					return Moment(row.SRDate).format("DD-MMM-YYYY");
						}
						},
						
	  
      {    dataField: "Action",
          text: "Action",
          classes: "actionbtncustm",
          isDummyField: true,
          editable: false,
          formatter: (cellContent, row) => {
            return (
              <span>
                <span className="saveBtnUs">
                  {/* <img src={terminationLogo}
                             alt="logo" className="logo-user" title='Generate SR' onClick={() => {this.handleShow('New')}}/> */}
                  <Link
                    target="_blank"
                    to={`/service-report-preview/${row.ID}`}
                    onClick={() =>
                      this.navigateToServiceReportPreviewSigned(row.ID)
                    }
                    className="linkPage"
                  >
                    <MdOutlinePreview size={20} title="Preview" />{" "}
                  </Link>
                </span>
                 <span
                  className="saveBtnUsMi cursorPoint marginLeft"
                  onClick={() => this.handleDeleteGeneratedJob(row)}
                  // disabled={item?.deleted}
                >
                  <FaMinusCircle className="btnClassMinus" />
                </span> 
              </span>
            );
          },
        },
      ];
    } 
	else if (this.state.statusId === "40") {
      columns = [
        {
          dataField: "InvoiceID",
          text: "Invoice #",
          // filter: textFilter({ className: "filter_class" }),
          classes: "cursorPoint id-width",
          // sort: true,
          // events: {
          //   onClick: (e, column, columnIndex, row, rowIndex) => {
          //     this.handleShow("Invoice", row);
          //   },
          // },
        },
        {
          dataField: "CustomerName",
          text: "Customer",
          classes: "cursorPoint customerName-Width",
          filter: textFilter({
            className: "filter_class",
            getFilter: (filter) => {
              this.setState({ customerNameFilter: filter });
            },
          }),
          sort: true,
        },
        {
          dataField: "JobSRIds",
          text: "SRs",
          filter: textFilter({
            className: "filter_class",
            getFilter: (filter) => {
              this.setState({ jobFilter: filter });
            },
          }),
          sort: true,
        
        },
        {
          dataField: "DocDate",
          text: "Invoice Date",
          classes: "cursorPoint srDate-Width",
          formatter: (cellContent, row) => {
            return Moment(row.DocDate).format("DD-MMM-YYYY");
          },
        },
	
      {    dataField: "Action",
          text: "Action",
          classes: "actionbtncustm",
          isDummyField: true,
          editable: false,
          formatter: (cellContent, row) => {
            return (
              <span>
                <span className="saveBtnUs">
                  {/* <img src={terminationLogo}
                             alt="logo" className="logo-user" title='Generate SR' onClick={() => {this.handleShow('New')}}/> */}
                  <Link
                    target="_blank"
                    to={`/service-report-preview/${row.ID}`}
                    onClick={() =>
                      this.navigateToServiceReportPreviewInvoice(row.ID)
                    }
                    className="linkPage"
                  >
                    <MdOutlinePreview size={20} title="Preview" />{" "}
                  </Link>
                </span>
              </span>
            );
          },
        },
      ];
    } 
	else if (this.state.statusId === "0") {
      columns = [
        {
          dataField: "JobID",
          text: "Job#",
          formatter: (cellContent, row) => {
            let className = "linkPage";
            let statusText = cellContent;

            if (row.JobStatus === "Validated") {
              className += " orangeText"; // Define a class for orange color
              statusText = "Validated";
            } else if (row.JobStatus === "HOApproved") {
              className += " greenText"; // Define a class for orange color
              statusText = "HOApproved";
            }

            return (
              <span className="linkPage">
                {cellContent}{" "}
                <IoIosInformationCircle
                  className={className}
                  size={15}
                  title={statusText}
                />{" "}
              </span>
            );
          },
          classes: (cell, row, rowIndex, colIndex) => {
            var currnetMonthData = this.state.currnetmonthdata;
            var currnetMonth = "";
            if (currnetMonthData === "") {
              currnetMonth = new Date();
            } else {
              currnetMonth = currnetMonthData;
            }
            var StatusValue = ["60", "80"];
            var dateVali = false;
            var selectedMonthData = Moment(currnetMonth).format("MM");
            var currentMonthData = Moment(new Date()).format("MM");
            var checkDate =
              Moment(currentMonthData).isBefore(selectedMonthData);
            dateVali = checkDate;

            if (this.state.Permission === "VALIDATE_JOB") {
              if (this.state.statusId === "10") {
                return "cursor jobidtd";
              }
            } else if (this.state.Permission === "AUTHORIZE_JOB") {
              if (
                this.state.statusId === "60" ||
                this.state.statusId === "80"
              ) {
                if (
                  this.state.submitbtn === true &&
                  StatusValue.some(
                    (element) => element === this.state.statusId
                  ) === true
                ) {
                  return "cursor jobidtd";
                } else {
                  return "jobidtd";
                }
              }
            } else {
              return "jobidtd";
            }
          },
          sort: true,
          headerClasses: "jobidtd",
          filter: textFilter({
            className: "filter_class",
            getFilter: (filter) => {
              this.setState({ srIdFilter: filter });
            },
          }),
        },
        {
          dataField: "CustomerName",
          text: "Customer",
          sort: true,
          headerClasses: "customertd",
          classes: "customertd",
          filter: textFilter({
            className: "filter_class",
            getFilter: (filter) => {
              this.setState({ customerNameFilter: filter });
            },
          }),
        },
        {
          dataField: "JobType",
          text: "Work",
          sort: true,
          headerClasses: "jobtypetd",
          classes: "jobtypetd",
          filter: textFilter({
            className: "filter_class",
            getFilter: (filter) => {
              this.setState({ jobFilter: filter });
            },
          }),
        },
        {
          dataField: "TechNames",
          text: "Technicians",
          headerClasses: "technametd",
          classes: "technametd",
        },
        {
          dataField: "Remarks",
          text: "Remarks",
          headerClasses: "remarktd",
          classes: "remarktd",
        },
        {
          dataField: "Measures",
          text: "Measurements",
          headerClasses: "measurestd",
          classes: "measurestd",
        },
       
        {
          dataField: "Department",
          text: "Dept",
          sort: true,
          headerClasses: "departmenttd",
          classes: "departmenttd",
          filter: textFilter({ className: "filter_class" }),
        },
        {
          dataField: "ConveyorReference",
          text: "Conv Ref",
          sort: true,
          headerClasses: "conveyorreferencetd",
          classes: "conveyorreferencetd",
          filter: textFilter({ className: "filter_class" }),
        },
        {
          dataField: "JobDates",
          text: "Date & Time",
          headerClasses: "jobdatetd",
          classes: "jobdatetd",
        },
        {
          dataField: "NumberOfCasuals",
          headerClasses: "numberofcasualtd",
          text: "Casuals",
          classes: "numberofcasualtd",
        },
      ];
    } else {
      columns = [
        {
          dataField: "ID",
          text: "Pick #",
          classes: "cursorPoint pickListWidth",
          filter: textFilter({
            className: "filter_class",
            getFilter: (filter) => {
              this.setState({ srIdFilter: filter });
            },
          }),
          sort: true,
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              this.handleShow_WO("New", row);
            },
          },
        },
        {
          dataField: "CustomerName",
          text: "Customer",
          filter: textFilter({
            className: "filter_class",
            getFilter: (filter) => {
              this.setState({ customerNameFilter: filter });
            },
          }),
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              this.handleShow_WO("New", row);
            },
          },
          sort: true,
          classes: "cursorPoint pickListNameWidth",
        },
        {
          dataField: "JobSRTypeIds",
          text: "Jobs",
          filter: textFilter({
            className: "filter_class",
            getFilter: (filter) => {
              this.setState({ jobFilter: filter });
            },
          }),
          sort: true,
          events: {
            onClick: (e, column, columnIndex, row, rowIndex) => {
              this.handleShow_WO("New", row);
            },
          },
          classes: "cursorPoint",
          formatter: (cellContent, row) => {
            return <span className="linkPage">{cellContent}</span>;
          },
        },
	
	
	  {
			  dataField: "Action",
          text: "Action",
          classes: "actionbtncustm",
          isDummyField: true,
          editable: false,
          formatter: (cellContent, row) => {
            return (
              <span>
                <span className="saveBtnUs">
                  {/* <img src={terminationLogo}
                             alt="logo" className="logo-user" title='Generate SR' onClick={() => {this.handleShow('New')}}/> */}
                  <Link
                    target="_blank"
                    to={`/service-report-preview/${row.ID}`}
                    onClick={() =>
                      this.navigateToServiceReportPreviewPickList(row.ID)
                    }
                    className="linkPage"
                  >
                    <MdOutlinePreview size={20} title="Preview" />{" "}
                  </Link>
                </span>
                 {!row.Locked ? (
					<span
										className="saveBtnUsMi cursorPoint marginLeft"
										onClick={() => this.handleDeletePickJob(row)}
										// disabled={item?.deleted}
					>
					<FaMinusCircle className="btnClassMinus" title="Delete" />
					</span>
									) : (
					<span
										className="saveBtnUsDi cursorPoint marginLeft"
										//onClick={() => this.handleDeletePickJob(row)}
										// disabled={item?.deleted}
					>
					<FaMinusCircle className="btnClassMinus" title="Delete" />
					</span>
									)} 
									
				
              </span>
            );
          },
        },
      ];
    }

    const StartDateCustomInput = React.forwardRef(({ value, onClick }, ref) => (
      <button className="start-custom-input" onClick={onClick} ref={ref}>
        {value ? Moment(value).format("DD-MMM-YYYY") : "Start Date"}
      </button>
    ));

    const EndDateCustomInput = React.forwardRef(({ value, onClick }, ref) => (
      <button className="start-custom-input" onClick={onClick} ref={ref}>
        {value ? Moment(value).format("DD-MMM-YYYY") : "End Date"}
      </button>
    ));

    const columnsOther = [
      {
        dataField: "Job",
        text: "Job #",
        editable: false,
      },
      {
        dataField: "Customer",
        text: "Customer",
        editable: false,
      },
      {
        dataField: "Work",
        text: "Work",
        editable: false,
      },
      {
        dataField: "Measurements",
        text: "Measurements",
        editable: false,
      },
      {
        dataField: "JobDate",
        text: "Job Date",
        editable: false,
      },
      {
        dataField: "Work",
        text: "Work",
        editCellClasses: "editing-name",
      },
      {
        dataField: "Measurements",
        text: "Measurements",
        editCellClasses: "editing-name",
      },
      {
        dataField: "JobDate",
        text: "Job Date",
        editCellClasses: "editing-name",
      },
    ];
    var servicereportData = this.state.srdetails;
    var expandRow = {};

    const selectRow = {
      mode: "checkbox",
      clickToSelect: true,
      selected: this.state.selectedRows.map((row) => row.ID || row.JobID),
      className: "checkbox-column",
      hideSelectAll: false, // Show the "Select All" checkbox

      // Individual row selection
      onSelect: (row, isSelect, rowIndex, e) => {
        let updatedSelectedRows;
        if (isSelect) {
          // If row is selected, add it to the selectedRows array
          updatedSelectedRows = [...this.state.selectedRows, row];
        } else {
          // If row is unselected, remove it from selectedRows array
          {
            this.state.statusId === "30"
              ? (updatedSelectedRows = this.state.selectedRows.filter(
                  (selectedRow) =>
                    selectedRow.ID !== row.ID && selectedRow.ID !== row.ID
                ))
              : (updatedSelectedRows = this.state.selectedRows.filter(
                  (selectedRow) =>
                    selectedRow.JobID !== row.JobID &&
                    selectedRow.JobID !== row.JobID
                ));
          }
        }
        this.setState({
          selectedRows: updatedSelectedRows,
        });

        // Check if there are different CustomerNames in selectedRows array
        const customerNames = updatedSelectedRows.map(
          (row) => row.CustomerName
        );
        if (new Set(customerNames).size > 1) {
          // If there are different customer names
          this.setState({
            pickbtnEnabled: false,
          });
        } else {
          this.setState({
            pickbtnEnabled: true,
          });
        }
      },

      // "Select All" functionality
      onSelectAll: (isSelect, rows, e) => {
        let updatedSelectedRows;
        if (isSelect) {
          // If "Select All" is clicked, add all rows to selectedRows array
          updatedSelectedRows = [...this.state.selectedRows, ...rows];
        } else {
          // If "Deselect All" is clicked, remove all rows from selectedRows array
          updatedSelectedRows = [];
        }
        this.setState({
          selectedRows: updatedSelectedRows,
        });

        // Check if there are different CustomerNames in selectedRows array
        const customerNames = updatedSelectedRows.map(
          (row) => row.CustomerName
        );
        if (new Set(customerNames).size > 1) {
          this.setState({
            pickbtnEnabled: false,
          });
        } else {
          this.setState({
            pickbtnEnabled: true,
          });
        }
      },

      hideSelectColumn:
        this.state.statusId === "0" || this.state.statusId === "30"
          ? false
          : true,
    };

   const pickbtnEnabled =
      this.state.selectedRows.length > 0 && this.state.pickbtnEnabled;

    const [startDateRange, endDateRange] = this.state.dateRange;

    console.log(startDateRange, endDateRange);

    const hasEmptySRDetail = SRData.some(
      (item) => !item.deleted && item.SRJobDetails === ""
    );

    const fetchbtnEnabled = startDateRange && endDateRange;
    return (
      <div>
        <HeaderBack />
        <div className=" container jobfilter mb-4 mt-4">
          <div className="headerfilter-user">
            <div className="filterbtnsite">
              <Dropdown onSelect={this.handleDropdownSite}>
                <Dropdown.Toggle
                  variant="warning"
                  className="font_size"
                  id="dropdown-basic"
                >
                  {this.state.selectedSite}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {listSiteId !== ""
                    ? listSiteId.map((item, indexdata) => {
                        return (
                          <Dropdown.Item
                            className="font_size"
                            key={indexdata}
                            eventKey={item.key}
                          >
                            {item.value}
                          </Dropdown.Item>
                        );
                      })
                    : ""}
                </Dropdown.Menu>
              </Dropdown>
            </div>

            <div
              className={
                this.state.statusId === "0" || this.state.statusId === "30"
                  ? "filterbtndrop"
                  : "filterbtn"
              }
            >
              <Dropdown onSelect={this.handleDropdown}>
                <Dropdown.Toggle
                  variant="info"
                  className="font_size"
                  id="dropdown-basic"
                >
                  {this.state.selectedStatus}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {listStatus.map((item, index) => {
                    return (
                      <Dropdown.Item
                        className="font_size"
                        key={index}
                        eventKey={item.key}
                      >
                        {item.value}
                      </Dropdown.Item>
                    );
                  })}
                </Dropdown.Menu>
              </Dropdown>
            </div>
           {/* {this.state.statusId === "0" ? ( Previous logic */ }
			{(this.state.statusId === "0" || this.state.statusId === "10") ? (
              <div
                ref={this.wrapperRef}
                className="filterbtndate dateRangePicker"
              >
                <button
                  className="btn dateRange-btn"
                  onClick={this.toggleCalendar}
                >
                  <IoCalendarNumberOutline
                    size={30}
                    className="calendar-icon"
                  />
                </button>
                <DatePicker
                  // selected={this.state.startDateRangeData}
                  onChange={(update) => {
                    this.handleInputChange(update);
                  }}
                  startDate={startDateRange}
                  endDate={endDateRange}
                  open={this.state.calendarOpen}
                  dateFormat="dd-MMM-yyyy"
                  placeholderText="Select Period"
                  className="form-control fontSize daterange"
                  // isClearable={true}
                  selectsRange={true}
                  minDate={new Date(2024, 2, 1)}
                  maxDate={new Date()}
                  // readOnly={true}
                />
                <div className="showDateRange">
                  {startDateRange
                    ? Moment(startDateRange).format("DD-MMM-YYYY")
                    : ""}
                  {endDateRange
                    ? " - " + Moment(endDateRange).format("DD-MMM-YYYY")
                    : ""}
                </div>
              </div>
            ) : (
              ""
            )}
            <div className="filterbtn">
              <Button
                variant="primary"
                className={`font_size ${
                  this.state.statusId === "0" && !endDateRange
                    ? "disabledBtn"
                    : ""
                }`}
                disabled={this.state.statusId === "0" ||  this.state.statusId === "10" && !endDateRange}
			//	disabled={(this.state.statusId === "0" && !endDateRange) ||  this.state.statusId === "10" && !endDateRange}
                onClick={this.handleInputFetch}
				disabled={this.isFetchDisabled()}
              >
                Fetch
              </Button>
              {this.state.statusId === "0" && (
                <span className="pickbtn-note">
                  <IoIosInformationCircle
                    size={20}
                    onMouseEnter={this.handleMouseEnterFetch}
                    onMouseLeave={this.handleMouseLeaveFetch}
                  />
                </span>
              )}
              {this.state.showTooltipBox && (
                <div
                  style={{
                    position: "absolute",
                    top: "100%",
                    width: "150px",
                    // left: "50%",
                    transform: "translateX(-50%)",
                    backgroundColor: "rgba(0, 0, 0, 0.8)",
                    color: "#fff",
                    padding: "5px 10px",
                    borderRadius: "5px",
                    zIndex: 9999,
                  }}
                >
                  Select Period and Click on the fetch button.
                </div>
              )}
            </div>
          </div>
          <div className="submiteditbtnsr" style={{ position: "relative" }}>
            {this.state.statusId === "30" || this.state.statusId === "0" ? (
              // this.state.Permission === "VALIDATE_JOB" ? (
              <>
                <Button
                  variant="warning"
                  className={`font_size ${pickbtnEnabled ? "" : "disabledBtn"}`}
                  onClick={this.handleSavePick}
                  disabled={!pickbtnEnabled}
                >
                  Pick
                </Button>
                <span className="pickbtn-note">
                  <IoIosInformationCircle
                    size={20}
                    onMouseEnter={this.handleMouseEnter}
                    onMouseLeave={this.handleMouseLeave}
                  />
                </span>
                {this.state.showTooltip && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      // left: "50%",
                      transform: "translateX(-50%)",
                      backgroundColor: "rgba(0, 0, 0, 0.8)",
                      color: "#fff",
                      padding: "5px 10px",
                      borderRadius: "5px",
                      zIndex: 9999,
                    }}
                  >
                    The Pick button is disabled until a job is selected (or) if
                    multiple customers jobs are selected.
                  </div>
                )}
              </>
            ) : (
              // ) : (
              //   <span className="submiteditbtnsrOther"></span>
              // )
              <span className="submiteditbtnsrOther"></span>
            )}
            {/* <img src={addUserLogo}
                             alt="logo" className="logo-add-user" title='Generate SR'  onClick={() => {this.handleShow('New')}}/> */}
          </div>
		  </div>
        <div className="table-container-user">
          <BootstrapTable
            ref={this.bootstrapTableRef} // Assign the ref to your Bootstrap Table
            classes={
              this.state.statusId === "0" || this.state.statusId === "30"
                ? "tabledata-user-other"
                : "tabledata-user-data"
            }
            keyField={`${this.state.statusId === "30" ? "ID" : "JobID"}`}
            id="tabledata"
            data={servicereportData}
            columns={columns}
            expandRow={expandRow}
            selectRow={selectRow}
            filter={filterFactory({ className: "custom_filter_class" })}
            loading={this.state.loading}
            noDataIndication={this.state.loadingData}
          />
        </div>
        <Offcanvas
          className={
            this.state.selectedBtn === "Invoice"
              ? "useroff-in"
              : "useroff-other"
          }
          show={this.state.showData}
          scroll={this.state.scroll}
          name={this.state.name}
          backdrop={this.state.backdrop}
          placement={this.state.placement}
          onHide={this.handleClose}
        >
          <Offcanvas.Header className="popup_header" closeButton>
            <Offcanvas.Title className="header_title">
              {this.state.selectedBtn === "New" ? (
                <span className="title_contant">
                  Pick List No: {this.state.customerJobData.ID} -{" "}
                  {this.state.customerJobData.CustomerName}
                </span>
              ) : this.state.selectedBtn === "Invoice" ? (
                <span className="title_contant">
                  {/* {this.state.invoiceData[0].CustomerID} -{" "} */}
                  {this.state.invoiceData[0].CustomerName}
                </span>
              ) : (
                <span className="title_contant">
                  SR No/Date : {this.state.customerJobData.ID} /{" "}
                  {Moment(this.state.customerJobData.SRDate).format(
                    "DD-MMM-YYYY"
                  )}{" "}
                  - {this.state.customerJobData.CustomerName}
                </span>
              )}
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="container">
              <div className="rowUser justify-content-center">
                <div className="col-md-12">
                  {this.state.selectedBtn === "New" ? (
                    <form
                      className="pr-5 mb-5 formUser"
                      method="POST"
                      onSubmit={this.handleAddCustomer}
                    >
					
					<div style={{ display: "flex", gap: "8px", marginBottom: "10px" }}>
						 
						 <Button variant="primary" size="sm" disabled={this.state.selectedRows.length < 2} onClick={this.handleMergeRows}>Merge</Button>
						  <Button variant="primary" size="sm" onClick={this.handleDuplicateRow}>Split Row</Button>
						   
						  </div>

                      <div className="rowUserpickList">
                        <div className="col-md-3 form-group input-user dateCol">
                          <label className="fontSize labelWidth">
                            SR Date* :{"  "}
                          </label>
                          <DatePicker
                            selected={this.state.srSaveDate}
                            onChange={(date) => {
                              this.handleSrSaveDateChange(date);
                            }}
                            dateFormat="dd-MMM-yyyy"
                            // minDate={this.state.startDate}
                            //  disabled={this.state.Permission !== "VALIDATE_JOB"}
                            maxDate={this.state.lasttdate}
                            minDate={
                              new Date(
                                Math.max.apply(
                                  null,
                                  SRData.map(
                                    (data) => new Date(data?.JobEndDate)
                                  )
                                )
                              )
                            }
                            required
                            placeholderText="  Select Date"
                            className="form-control"
                          />
                        </div>
                      </div>
                      	<div className="rowUser">
							  <div className="form-group" style={{ width: "100%",maxHeight: "500px",overflowY: "auto",overflowX: "hidden" }}>
								<Table bordered responsive className="tableAdd" style={{ marginBottom: 0 }}>
								  <thead className="padding-table-header" >
							
                              {/* <th>Sr #<span className="required"> *</span></th> */}
							  			  
							  <th 
								className=" alginCenter col-md-1 colorHeader"
                                style={{ width: "3%",
									  textAlign: "center",
									  verticalAlign: "middle",
									  padding: "3px",}}>
									<input
									  type="checkbox"
									  
									  checked={
										this.state.selectedRows.length > 0 &&
										this.state.selectedRows.length === this.state.SRData.length
									  }
									  onChange={(e) => this.handleSelectAllRows(e)}
									/>

								</th>
								
								
                              <th
                                className=" alginCenter col-md-1 colorHeader"
                                style={{
									width: "10%",
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                  padding: "3px",}}>
                                Job ID<span className="required"></span>
                              </th>
							  <th
                                className=" alginCenter col-md-1 colorHeader"
                                style={{
									width: "11%",
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                  padding: "3px",}}>
                                Job Type<span className="required"></span>
                              </th>
                              <th
                                className="alginCenter col-md-5 colorHeader"
                                style={{
									width: "8%",
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                  position: "relative",
                                }}
                              >
                                <span> Actual Job Details </span>

                                <span
                                  className="copy-all-button ml-2"
                                  onClick={() => this.copyAllTasks()}
                                >
                                  <FiChevronsRight
                                    size={25}
                                    title="Copy All"
                                    color="green"
                                  />
                                </span>
                              </th>
                              <th
                                className="alginCenter col-md-5 colorHeader"
                                style={{
									width: "8%",
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                }}
                              >
                                SR Job Details
                              </th>
							   <th 
							   className="alginCenter col-md-5 colorHeader"
                                style={{
									width: "8%",
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                }}
							   >Actual UOM</th>
                              <th className="alginCenter col-md-5 colorHeader" style={{width: "15%",textAlign: "center", verticalAlign: "middle"}}>Pending Workorder List</th>
                              <th className="alginCenter col-md-5 colorHeader" style={{width: "6%",textAlign: "center",verticalAlign: "middle"}}>Job Qty</th>
                              <th className="alginCenter col-md-5 colorHeader" style={{textAlign: "center",width: "10%", minWidth: "80px" }}>Rate</th>
                              <th className="alginCenter col-md-5 colorHeader" style={{textAlign: "center",width: "10%", minWidth: "80px" }}>Pending Bill Qty</th>
		                      <th className="alginCenter col-md-5 colorHeader"style={{width: "8%",textAlign: "center",verticalAlign: "middle"}} >Billing/Hold</th>
                              

							{this.state.SRData.some((r) => r.BillingHold === false) && (
							<th className="alginCenter col-md-5 colorHeader"
                                style={{
									width: "18%",
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                }}
							  
							>Expected Billing Date</th> 
							)}
								{this.state.SRData.some((r) => r.BillingHold === false) && (
							   <th className="alginCenter col-md-5 colorHeader"
                                style={{
									width: "18%",
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                }}
							  
								>Upload Service Report</th>)}


							   <th className="alginCenter col-md-5 colorHeader"
                                style={{
									width: "18%",
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                }}
							  
							  >Action</th>
							  
                            </thead>
                            <tbody>
							
                          {SRData.map((row, index) => (
							  <tr key={index}>
							  
							  <td style={{ textAlign: "center" }}>
								  {row.JobID || row.ID ? (
									<input
									  type="checkbox"
									  disabled={row.PickRowLocked}
								//	  checked={this.state.selectedRows.some((selected) =>(selected.JobID && selected.JobID === row.JobID) || (selected.ID && selected.ID === row.ID))}
									checked={this.state.selectedRows.some((r) =>(r.JobID && r.JobID === row.JobID) ||(r.ID && r.ID === row.ID))}
										onChange={(e) => this.handleRowSelect(e, row)}
									  
									/>
								  ) : (
									<span style={{ color: "red" }}>Invalid Row</span>
								  )}
								</td>
				   
								<td>
								  <div
									className="form-control noBorder JobID"
									style={{ margin: 0, textAlign: "center" }}
								  >
									{row.JobID}
								  </div>
								</td>
								<td>
								  <div
									className="form-control noBorder JobType"
									style={{ margin: 0, textAlign: "center" }}
								  >
									{row.JobType}
								  </div>
								</td>
								
								<td style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
								  <div
									className="form-control noBorder srJobDetailWidth"
									style={{ whiteSpace: "pre-wrap", margin: 0, padding: "4px 6px" }}
								  >
									{row.ActualJobDetails}
								  </div>
								  <span
									className="cursorPoint ml-2"
									onClick={() => this.copyActualJobDetails(index)}
									title="Copy this task"
								  >
									<FiChevronsRight size={18} color="green" />
								  </span>
								</td>

								<td>
								  <textarea
									className="form-control noBorder srJobDetailWidth"
									required={true}
									style={{
									  display: "flex",alignItems: "center",justifyContent: "center",resize: "none",height: "120px"}}
									value={row.SRJobDetails || ""}
									onChange={(e) => {
									  this.handleFieldChange(e, row, "SRJobDetails");

									  e.target.style.height = "auto";   // reset height
									  e.target.style.height = `${e.target.scrollHeight}px`; // adjust to content
									}}
									placeholder="Enter Job detail"
								  />
								</td>						
									<td>
									  <textarea
										type="text"
										className="form-control noBorder SpliceUOM"
										style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          minHeight: "95px",
                                          resize: "none",
										  }}
										placeholder="Enter Actual UOM"
										value={row.SpliceUOM || ""}

										onChange={(e) => this.handleFieldChange(e, row, "SpliceUOM")}
									  />
									</td>						
								
							<td>
							  <div style={{ width: "100%",marginBottom: "6px" }}>  
								<Button 
								  variant="info"
								  size="sm"
								  style={{ fontSize: "12px", padding: "2px 6px", lineHeight: "1.2", width: "100%" }}  
								   onClick={() => this.handleFetchWorkorderList(row)}
								   disabled={row.PickRowLocked}								 
								>
								  Get Workorder List
								</Button>
								
								<Button 
									  variant="info"
									  className="sm"
									  style={{ fontSize: "12px", padding: "2px 6px", lineHeight: "1.2", width: "100%" }}  
									  onClick={() => this.handleGetWorkorderListWithoutJobType(row)}
									  disabled={row.PickRowLocked}
									>
									  Get Workorder Without JobType
									</Button>
								
								<textarea
								  className="form-control mt-2"
								  rows="4"
								  style={{fontSize: "12px", fontFamily: "Arial, sans-serif", width: "100%", resize: "vertical",boxSizing: "border-box",height: "185px"}}  // Full width textarea
								  //value={this.state.workorderText}
								    value={row.PendingWorkorderList || ""}
								  readOnly
								/>

								{row.WorkorderLines && (
								  <div style={{ marginTop: "8px" }}>
									<textarea
									  readOnly
									  rows={4}
									  style={{ fontSize: "12px", fontFamily: "Arial, sans-serif", width: "100%", resize: "vertical" }}
									  value={row.WorkorderLines}
									/>
								  </div>
								)}
							  </div>
							</td>
								 
								<td>
								  {row.BillingHold === false ? (
									<textarea
									  type="text"
									  className="form-control noBorder Qty"
									  placeholder="Enter Qty"
									  style={{display: "flex",alignItems: "center",justifyContent: "center",minHeight: "95px",resize: "none",fontSize: "12px",fontFamily: "Arial, sans-serif",width: "100%"}}
									  value={row.Qty || ""}
									  
									  onChange={(e) => this.handleFieldChange(e, row.JobID,index, "Qty")}
									/>
								  ) : (
									<textarea
									  readOnly
									  type="text"
									  className="form-control noBorder Qty"
									  placeholder="Enter Qty"
									  style={{fontSize: "12px",fontFamily: "Arial, sans-serif",width: "60px",resize: "vertical"}}
									  value={row.Qty || ""}
									/>
								  )}
								</td>


								<td>
							  {row.BillingHold === false ? (
								<textarea
								  type="text"
								  className="form-control noBorder Rate"
								  placeholder="Enter Rate"
								  style={{display: "flex",alignItems: "center",justifyContent: "center",minHeight: "95px",resize: "none",fontSize: "12px",fontFamily: "Arial, sans-serif",width: "100%",
								  }}
								  value={row.Rate || ""}
								 onChange={(e) => this.handleFieldChange(e, row.JobID, index,  "Rate")}
								/>
							  ) : (
								<textarea readOnly type="text"className="form-control noBorder Rate"placeholder="Enter Rate"
								  style={{
									display: "flex",alignItems: "center",justifyContent: "center",minHeight: "95px",
									resize: "none",fontSize: "12px",fontFamily: "Arial, sans-serif",width: "100%",}}
								  value={row.Rate || ""}
								/>
							  )}
							</td>

								<td>
								  {row.BillingHold === false ? (
									<textarea
									  type="text"
									  className="form-control noBorder BillQty"
									  placeholder="Enter Pending BillQty"
									  style={{display: "flex",alignItems: "center",justifyContent: "center",minHeight: "95px",resize: "none",fontSize: "12px",fontFamily: "Arial, sans-serif",width: "100%",
									  }}
									  value={row.PendingBillQty || ""}
									  onChange={(e) => this.handlePendingBillQtyChange(e.target.value, row)}
									/>
								  ) : (
									<textarea readOnly
									  type="text" className="form-control noBorder BillQty" placeholder="Enter Pending BillQty"
									  style={{
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
										minHeight: "95px",
										resize: "none",
										fontSize: "12px",
										fontFamily: "Arial, sans-serif",
										width: "100%",
									  }}
									  value={row.PendingBillQty || ""}
									/>
								  )}
								</td>

								<td>
								  <Form.Select
									value={row.BillingHold}
									disabled={row.PickRowLocked}
									onChange={(e) =>this.handleDataChangeCheckList(index)({target: { name: "BillingHold", value: e.target.value },})}
									style={{
									  backgroundColor: "#17a2b8", // Bootstrap info blue
									  color: "white",fontSize: "12px",padding: "2px 6px",lineHeight: "1.2",border: "none",borderRadius: "4px",minWidth: "80px",
									}}
								  >
									<option value="">Select</option>
									<option value="true">Billing</option>
									<option value="false">Hold</option>
								  </Form.Select>
								  {console.log(row.BillingHold)}
								</td>
								 <td  style={{ minWidth: "120px", textAlign: "center" }}>
									{row.BillingHold === false ? (
										  <DatePicker
											selected={row.ExpectedBillingDate ? new Date(row.ExpectedBillingDate) : null}
											// disabled={this.isRowReadOnly(row)}
											onChange={(date) => this.handleExpectedBillingDateChange(date, row)}
											placeholderText="Choose Date"
											dateFormat="dd-MMM-yyyy"
											className="form-control blueDatePicker"
										  />
										) : (
										  <div style={{ minHeight: "38px" }}></div>
										)}
									  </td>
									
								
								<td>
								  {row.BillingHold === false ? (
									<div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
									  <label
										className="btn btn-info btn-sm"
										style={{minWidth: "120px", textAlign: "center",cursor: "pointer",display: "inline-block"}}
									  >Choose File
										<input
										  type="file"
										  onChange={(e) => this.handleFileUpload(e, row)}
										  style={{ display: "none" }}
										/>
									  </label>
									  {row.selectedFileName && (
										<small style={{ marginTop: "4px", color: "#555" }}>
										  {row.selectedFileName}
										</small>
									  )}
									</div>
								  ) : (
									<div style={{ minHeight: "38px" }}></div> // keeps alignment
								  )}
								</td>
								
								
								<td className="alginCenter">
								      
                                      <span
										  className="saveBtnUsMi cursorPoint marginLeft"
										  onClick={() => this.handleDataRemoveDetails(row)} 
										>
										  <FaMinusCircle className="btnClassMinus" title="Delete" />
									  </span>						  
                                    </td>
									
							  </tr>
							))}
						    </tbody>
                          </Table>
                        </div>
                      </div>
                      <div className="edit_input submitbtn mt-3">
                     
					   <button
							  type="button"
							  onClick={() => {this.setState({ invoicedNumber: 0 }, () => {this.handleSaveSignedJobWithWorkorder();});}}
							  disabled={this.state.SRData[0]?.PickLocked}							  
							  className={`btnval btn btn-success font_size ${this.state.SrDate || this.isSaveDisabled() ? "disabledBtn": ""}`}
							>
							  Save
							</button>
				       							
					   <Button
							type="button" variant="primary"
							onClick={() => {this.setState({ invoicedNumber: 1 }, () => {this.handleSaveSignedJobWithWorkorder();});}}
							disabled={this.state.SRData[0]?.PickLocked}
							className="btnval btn btn-primary font_size"
							>Submit
							</Button>
						
					   
					   
                        <button
                          type="button"
                          onClick={this.handleClose}						 
                          className="btnval btn btn-warning font_size">
                          Discard
                        </button>
						
						
						
                      </div>
                    </form> 
                  ) : (
                    ""
                  )}
                  {this.state.selectedBtn === "Upload Signed SR" ? (
                    <form
                      className="pr-5 mb-5 formUser"
                      method="POST"
                      onSubmit={this.handleAddCustomer}
                    >
                      <div className="rowUserpickList">
                        <div className="col-md-3 form-group input-user dateCol">
                          <label className="fontSize srlabelWidth">
                            Signed Date* :{" "}
                          </label>
                          <DatePicker
                            selected={this.state.srSaveDate}
                            onChange={(date) => {
                              this.handleSrSaveDateChange(date);
                            }}
                            dateFormat="dd-MMM-yyyy"
                            // minDate={this.state.startDate}
                            maxDate={this.state.lasttdate}
                            // disabled={this.state.Permission !== "VALIDATE_JOB"}
                            minDate={
                              new Date(this.state.generatedSrData.SRDate)
                            }
                            required
                            placeholderText="  Select Date"
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="rowUser mt-3 ">
                        <div className="col-md-12 form-group input-user">
                          <Table bordered responsive className="tableAdd">
                            <thead>
                              {/* <th>Sr #<span className="required"> *</span></th> */}
                              <th className=" alginCenter colorHeader">
                                Job #<span className="required">*</span>
                              </th>
                              <th className="alginCenter colorHeader">
                                Actual Job Details
                              </th>
                              <th className="alginCenter colorHeader">
                                SR Job Details
                              </th>

                              {/* <th className="alginCenter colorHeader">
                                Action
                              </th> */}
                            </thead>
                            <tbody>
                              {this.state.generatedSrData?.SRJobsDetail?.map(
                                (item, indexle) => {
                                  return (
                                    <tr
                                      className={`${
                                        item?.deleted ? "rowDisabled" : ""
                                      } `}
                                      key={indexle}
                                    >
                                      <td className="tableFontSize alginCenter">
                                        {item?.JobID}
                                      </td>
                                      <td className="tableFontSize alginCenter">
                                        {item?.ActualJobDetails}
                                      </td>

                                      <td className="tableFontSize alginCenter">
                                        {item?.SRJobDetails}
                                      </td>

                                     
                                    </tr>
                                  );
                                }
                              )}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                      <div className="row mt-3 ">
                        <span className="DottedClass"></span>
                        <div className="col-md-12 form-group input-user">
                          <Table bordered responsive>
                            <thead>
                              <th className="alginCenter colorHeader">
                                Document Name
                              </th>
                              <th className="alginCenter colorHeader">
                                Description
                              </th>
                              <th className="alginCenter colorHeader">
                                Uploaded By/On
                              </th>
                              <th className="alginCenter colorHeader taskWithPlus">
                                <span
                                  className="saveBtnUsPl cursorPoint"
                                  disabled={
                                    this.state.Permission !== "VALIDATE_JOB"
                                  }
                                  // onClick={
                                  //   this.state.Permission === "VALIDATE_JOB"
                                  //     ? () => {
                                  //         this.handleShowModal();
                                  //       }
                                  //     : null
                                  // }
                                  onClick={() => this.handleShowModal()}
                                >
                                  <FaPlusCircle title="Add" />
                                </span>
                              </th>
                              <th className="alginCenter"></th>
                            </thead>
                            <tbody>
                              {documentArr.length > 0 ? (
                                documentArr.map((item, indexdata) => {
                                  return (
                                    <tr key={indexdata}>
                                      <td className="alginCenter">
                                        {item.FileName}
                                      </td>
                                      <td className="alginCenter wrapDescription">
                                        {item.Description}
                                      </td>
                                      <td className="alginCenter">
                                        {item.UploadedBy +
                                          " / " +
                                          Moment(item.UploadedOn).format(
                                            "DD-MMM-YYYY"
                                          )}
                                      </td>

                                      <td className="alginCenter taskWithPlus">
                                        <span
                                          className="saveBtnUsMi cursorPoint"
                                          // onClick={
                                          //   this.state.Permission ===
                                          //   "VALIDATE_JOB"
                                          //     ? () =>
                                          //         this.handleDataRemoveImage(
                                          //           indexdata
                                          //         )
                                          //     : null
                                          // }

                                          onClick={() =>
                                            this.handleDataRemoveImage(
                                              indexdata
                                            )
                                          }
                                        >
                                          <FaMinusCircle title="Delete" />
                                        </span>
                                      </td>

                                      {/* <td className="alginCenter cursorPoint">
                                        <FaDownload
                                          onClick={() =>
                                            this.handleImageDownload(
                                              item.FileName,
                                              item.DocumentID
                                            )
                                          }
                                        />
                                      </td> */}
                                    </tr>
                                  );
                                })
                              ) : (
                                <tr>
                                  <td className="alginCenter" colSpan={5}>
                                    No Document Uploaded yet!
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                      <div className="edit_input submitbtn mt-3">
                        <button
                          type="button"
                          onClick={this.handleSaveGenerateJob}
                          disabled={
                            !this.state.srSaveDate || documentArr.length <= 0
                            // || this.state.Permission !== "VALIDATE_JOB"
                          }
                          className={`btnval btn btn-success font_size ${
                            this.state.srSaveDate && documentArr.length > 0
                            // || this.state.Permission !== "VALIDATE_JOB"
                            //   ? ""
                            //   : "disabledBtn"
                          }`}
                        >
                          Save
                        </button>
                        <button
                          type="button"
                          onClick={this.handleSignedGenerateJob}
                          disabled={
                            !this.state.srSaveDate || documentArr.length <= 0
                            // || this.state.Permission !== "VALIDATE_JOB"
                          }
                          className={`btnvalSr btn btn-primary font_size ${
                            this.state.srSaveDate && documentArr.length > 0
                            //  || this.state.Permission !== "VALIDATE_JOB"
                            //   ? ""
                            //   : "disabledBtn"
                          }`}
                        >
                          Signed SR
                        </button>
                        <button
                          type="button"
                          onClick={this.handleClose}
                          className="btnval btn btn-warning font_size"
                        >
                          Discard
                        </button>
                      </div>
                    </form>
                  ) : (
                    ""
                  )}
                  {this.state.selectedBtn === "Invoice" ? (
                    <form
                      className="pr-5 mb-5 formUser"
                      method="POST"
                      onSubmit={this.handleAddCustomer}
                    >
                      <div className="rowUser rowUserData">
                        <div className="col-md-6 form-group input-user">
                          <FloatingLabel
                            className="lableWidth"
                            label="Invoice #"
                          >
                            <Form.Control
                              className="edit_job_edit form__field"
                              type="text"
                              required={true}
                              name="invoicedNumber"
                              onChange={this.handleDataChangeOther}
                              value={this.state.invoicedNumber}
                              placeholder="Description"
                            />
                          </FloatingLabel>
                        </div>
                        <div className="col-md-6 form-group input-user">
                          <label className="fontSize">Invoice Date *</label>
                          <DatePicker
                            selected={this.state.srInvoicedDate}
                            onChange={(date) => {
                              this.handleSrSaveInvoiceDateChange(date);
                            }}
                            dateFormat="dd-MMM-yyyy"
                            minDate={
                              new Date(
                                Math.max.apply(
                                  null,
                                  this.state.invoiceData.map(
                                    (data) => new Date(data?.SRDate)
                                  )
                                )
                              )
                            }
                            maxDate={this.state.lasttdate}
                            required
                            placeholderText="Date *"
                            className="form-control selectAsealign"
                          />
                        </div>
                      </div>
                      <div className="rowUser">
                        <div className="col-md-12 form-group input-user">
                          <Table bordered responsive className="">
                            <thead>
                              {/* <th>Sr #<span className="required"> *</span></th> */}
                              <th className="taskWith colorHeader alginCenter">
                                SR #<span className="required">*</span>
                              </th>
                              <th className="alginCenter colorHeader">SR Dt</th>
                              {/* <th className="alginCenter taskWithPlus">
                                <span
                                  className="saveBtnUsPl cursorPoint"
                                  onClick={this.handleDataAddDetailsInvoice}
                                >
                                  <FaPlusCircle />
                                </span>
                              </th> */}
                            </thead>
                            <tbody>
                              {this.state.invoiceData.map((item, indexle) => {
                                return (
                                  <tr key={indexle}>
                                    <td className="tableFontSize alginCenter">
                                      
                                      {item?.SRID}
                                    </td>
                                    <td className="alginCenter">
                                      {Moment(item.SRDate).format(
                                        "DD-MMM-YYYY"
                                      )}
                                    </td>
                                    {/* <td>
                                      <span
                                        className="saveBtnUsMi cursorPoint"
                                        onClick={() =>
                                          this.handleDataRemoveDetailsInvoice(
                                            indexle
                                          )
                                        }
                                      >
                                        <FaMinusCircle className="btnClassMinus" />
                                      </span>
                                    </td> */}
                                  </tr>
                                );
                              })}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                      <div className="edit_input submitbtn mt-3">
						  <button
							type="button"
							onClick={this.handleSaveSignedJobWithWorkorder}
							//onClick={this.handleSaveSignedJob}
							// disabled={!this.state.srInvoicedDate || !this.state.invoicedNumber}
							disabled={!this.state.srInvoicedDate}
							className={`btnval btn btn-success font_size ${
							  this.state.srInvoicedDate ? "" : "disabledBtn"
							}`}
						  >
							Save
						  </button>
						  <button
							type="button"
							onClick={this.handleClose}
							className="btnval btn btn-warning font_size"
						  >
							Discard
						  </button>
						</div>

                    </form>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
        <Modal
          show={this.state.showModalBig}
          onHide={this.handleCloseModalBig}
          className="backModalBig"
          aria-labelledby="contained-modal-title-vcenter"
        >
          <Modal.Header closeButton>
            <Modal.Title
              id="contained-modal-title-vcenter"
              className="titleDataOther"
            >
              Uploaded Document
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="show-grid">
            <div className="container">
             
              <iframe
                src={this.state.viewFile}
                className="mainImage"
                width="1040"
                height="500"
              ></iframe>
              
            </div>
          </Modal.Body>
          
	  </Modal>
       
	   <Modal
          show={this.state.showModal}
          onHide={this.handleCloseModal}
          // dialogClassName="custom-dialog"
		  dialogClassName="backModal"
          className="backModal"
          aria-labelledby="contained-modal-title-vcenter"
        >
          <Modal.Header className="headerUpload" closeButton>
            <Modal.Title
              id="contained-modal-title-vcenter"
              className="titleData"
            >
              Upload Document
            </Modal.Title>
          </Modal.Header>
		  
          <form
            className="pr-5 formUser"
            method="POST"
            encType="multipart/form-data"
            onSubmit={this.handleChangeImage}
          >
            <Modal.Body className="show-grid modelImageBox">
              <div className="">
                <div className="rowUser justify-content-center imageUploadClass">
                  <div className="rowImage">
                    <div className="imagecol">
                      {this.state.imageData !== "" &&
                      this.state.imageData !== null &&
                      this.state.imageData !== undefined ? (
                        <p className="fileNameClass">{this.state.imageId}</p>
                      ) : (
                        <div className="profile-pic">
                          <label className="-label" htmlFor="file">
                            <span>&nbsp;</span>
                          </label>
                          <input id="file" type="file" name="fileimage"
                            onChange={this.handleChangeImageDataOther}
                            accept={this.state.AllowedFileExtensions}
                          />
                          <img src={this.state.image} id="output" width="200" />
                        </div>
                      )}
                      <p className="photoClass">
                        Supported file formats :{" "}
                        {this.state.AllowedFileExtensions}
                        <br />
                        Maximum file size : {this.state.MaxAllowedSize}
                      </p>
                      {/* <FloatingLabel
                        controlId="floatingTextarea2"
                        label="Description *"
                      > */}
                      <Form.Control
                        as="textarea"
                        placeholder="Description *"
                        name="Comment"
                        required={true}
                        // style={{ height: '185px' }}
                        onChange={this.handleDataChangeComment}
                        value={this.state.Comment}
                        className="font_size"
                      />
                      {/* </FloatingLabel> */}
                      <p className="photoClass mt-2">
                        <b>
                          Note: The uploaded documents will be saved only on the
                          click of the Save button in the next screen.
                        </b>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer className="footerModel">
              <button className="btn btn-success fontSize">Upload</button>
            </Modal.Footer>
          </form>
        </Modal>
        {this.state.lodingImagData === true ? (
          <span className="preloader">
            <img src={loadingImg} className="loaderImg" />
          </span>
        ) : (
          ""
        )}
		
	<Modal
  show={this.state.showWorkorderModal}
  onHide={() => this.setState({ showWorkorderModal: false })}
  size="lg"
>
  <Modal.Header
    closeButton
    className="bg-primary text-white py-1 px-3"
    style={{ backgroundColor: "#007bff", padding: "8px 16px" }}
  >
    <Modal.Title style={{ color: "white", fontSize: "14px" }}>
      Select Workorder Line ({this.state.workorderCustomer})
    </Modal.Title>
  </Modal.Header>

  <Modal.Body>
    {/* Filter Inputs + Clear Buttons */}
    <div className="mb-2 d-flex flex-column gap-2">
      {/* Workorder filter */}
      <div className="d-flex align-items-center gap-2">
        <Form.Control
          type="text"
          placeholder="Filter by Workorder Number..."
          value={this.state.workorderFilter || ""}
          onChange={(e) =>
            this.setState({ workorderFilter: e.target.value.toLowerCase() })
          }
          style={{ maxWidth: "320px" }}
        />
        <Button
          variant="outline-secondary"
          size="sm"
          onClick={() => this.setState({ workorderFilter: "" })}
        >
          Clear
        </Button>
      </div>

      

      <small className="text-muted">
        {this.state.workorderLines.length} total lines
      </small>
    </div>

    {/* Scrollable Table */}
    <div
      style={{
        maxHeight: "400px",
        overflowY: "auto",
        border: "1px solid #dee2e6",
        borderRadius: "4px",
      }}
    >
      <Table striped bordered hover size="sm" className="mb-0">
        <thead
          style={{
            position: "sticky",
            top: 0,
            background: "#f8f9fa",
            zIndex: 2,
          }}
        >
          <tr>
            <th style={{ width: "60px" }}>Select</th>
			
			 {/* <th>Linenum</th>  */}
            <th>WorkOrder</th>
            <th>ItemCode</th>
            <th>Description</th>
            <th>Qty</th>
            <th>UOM</th>
            <th>Price</th>
			<th>JobId_QTY</th>
			{this.state.allowJobQtyEdit && <th>JobId_QTY_Edited</th>}
          </tr>
        </thead>

        <tbody>
          {this.state.workorderLines
            .filter((line) => {
              const workorderFilter = this.state.workorderFilter?.trim().toLowerCase();
              const descFilter = this.state.descriptionFilter?.trim().toLowerCase();

              const workOrderStr = String(line.WorkOrderNumber || "").toLowerCase();
              const itemStr = String(line.ItemCode || "").toLowerCase();
              const descStr = String(line.Dscription || "").toLowerCase();

              // Apply both filters if set
              const workorderMatch =
                !workorderFilter ||
                workOrderStr.includes(workorderFilter) ||
                itemStr.includes(workorderFilter);

              const descriptionMatch =
                !descFilter || descStr.includes(descFilter);

              return workorderMatch && descriptionMatch;
            })
            .map((line, idx) => (
              <tr key={idx}>
                <td>
                  <input
                    type="radio"
                    name="workorderSelect"
                    onChange={() => this.handleSelectWorkorderLine(line)}
                    checked={
                      this.state.selectedWorkorderLine &&
                      this.state.selectedWorkorderLine.WorkOrderNumber ===
                        line.WorkOrderNumber &&
                      this.state.selectedWorkorderLine.ItemCode === line.ItemCode
                    }
                  />
                </td>
				 {/*<td>{line.Linenum}</td> */}
                <td>{line.WorkOrderNumber}</td>
                <td>{line.ItemCode}</td>
                <td>{line.Dscription}</td>
                <td>{line.Quantity}</td>
                <td>{line.unitMsr}</td>
                <td>{line.Price}</td>
				<td>{line.JobId_QTY}</td>
				{this.state.allowJobQtyEdit && (
					  <td>
						<input
						  type="number"
						  value={line.JobId_QTY_Edited || ""}
						  onChange={(e) => this.handleJobIdQtyChange(e.target.value, idx)}
						  style={{ width: "80px" }}
						/>
					  </td>
					)}

              </tr>
            ))}
        </tbody>
      </Table>
    </div>
  </Modal.Body>

  <Modal.Footer>
    <Button
      variant="secondary"
      onClick={() => this.setState({ showWorkorderModal: false })}
    >
      Cancel
    </Button>

    <Button variant="primary" onClick={this.handleSubmitWorkorderList}>
      Submit Workorder List
    </Button>
  </Modal.Footer>
</Modal>




      </div>
    );
  }
}
